//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// ScannerPage - InteractLite Order Items - Use the barcode scanner to select items to add to the order
//               Created: May 30, 2020
//               Version 1.003 - Nov 17, 21 - Cleanup List
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React,{ Component } from 'react';
import { Navigate } from 'react-router-dom'
import './App.css';
//import './custom.scss';            
import { Popup } from '@progress/kendo-react-popup';
import { ListView,ListViewHeader,ListViewFooter } from '@progress/kendo-react-listview';
import { Avatar } from '@progress/kendo-react-layout';
import { Rating } from "@progress/kendo-react-inputs";
import { TreeView } from '@progress/kendo-react-treeview';
import { Button } from '@progress/kendo-react-buttons';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Input } from '@progress/kendo-react-inputs';
import { SessionInfo } from './App';
import { BrowserMultiFormatReader,BarcodeFormat,DecodeHintType } from '@zxing/library'; // Barcode Scanner 
import PropTypes from "prop-types";
import { withRouter } from './withRouter';
import { ShoppingCart } from './shoppingCart.js';
import { CallOM,CallOMT,OMTrace,trace,displayMessage,displayWarning,displayError,GetFileExtension,CreateKeys,LogOffResetMsg,getImageFileFromServer,CTYP,TYP,NOTIFY,PingApp,SetNotify } from './CommonCode.js';
//
import { ReactComponent as MenuBar } from "./images/bars.svg";
import { ReactComponent as ButtonSearch } from "./images/search.svg";
import { ReactComponent as ButtonClear } from "./images/button-clear.svg";
import { ReactComponent as CartAdd } from "./images/purchase.svg";
import { ReactComponent as CartEdit } from "./images/edit.svg";
import { ReactComponent as List } from "./images/list.svg";
//                    
const hints = new Map()
const formats = [
  BarcodeFormat.CODE_128,
  BarcodeFormat.CODE_39,
  BarcodeFormat.QR_CODE
]
//BarcodeFormat.UPC_A,
//BarcodeFormat.UPC_E,
//BarcodeFormat.UPC_EAN_EXTENSION,

hints.set(DecodeHintType.POSSIBLE_FORMATS,formats)

//const codeReader = new BrowserMultiFormatReader(hints);
const codeReader = new BrowserMultiFormatReader();
var scanHT = 230;
var scanWD = 300;
var scannerHT = 0; // scanHT + 40;
const hideScannerAfterScan = true;

//------ Object Definition For StoreItems -- Date: 2024-04-04-1:59 PM ------
const StoreItemsOID = 544619; // NOTE ADDTIONAL COLUMNS; HasOptions , HasRelated  --- NOTE The Values for HasOptions and HasRelated provided in call to GetStoreItem ----
const StoreItemsO = [{ n: 'StoreItemID',t: 195,p: 100 },{ n: 'StoreLocationID',t: 195,p: 100 },{ n: 'ReferenceItemID',t: 195,p: 100 },{ n: 'AssociatedItemID',t: 195,p: 100 },{ n: 'ItemName',t: 21,p: 0 },{ n: 'ItemDescription',t: 21,p: 0 },{ n: 'ItemFullDescription',t: 29,p: 0 },{ n: 'ItemNote',t: 21,p: 0 },{ n: 'ProductItemCategoryID',t: 195,p: 100 },{ n: 'ProductItemGroupID',t: 195,p: 100 },{ n: 'ProductItemTypeID',t: 195,p: 100 },{ n: 'BrandID',t: 195,p: 100 },{ n: 'UPCNumber',t: 21,p: 0 },{ n: 'BarcodeNumber',t: 21,p: 0 },{ n: 'ItemStatusID',t: 195,p: 100 },{ n: 'PackagingTypeID',t: 195,p: 100 },{ n: 'ItemSizeCodeID',t: 195,p: 100 },{ n: 'TotalQuantity',t: 16,p: 0 },{ n: 'TotalNetWeight',t: 16,p: 0 },{ n: 'ReservedQuantity',t: 16,p: 0 },{ n: 'LockedQuantity',t: 16,p: 0 },{ n: 'AvailableQuantity',t: 16,p: 0 },{ n: 'DocumentID',t: 41,p: 0 },{ n: 'ImageID',t: 41,p: 0 },{ n: 'ItemPrice',t: 28,p: 0 },{ n: 'OverridePrice',t: 28,p: 0 },{ n: 'PromotionPrice',t: 28,p: 0 },{ n: 'Promotion2Price',t: 28,p: 0 },{ n: 'PromotionType',t: 201,p: 0 },{ n: 'StorePromotionID',t: 195,p: 100 },{ n: 'ShelfLifeDays',t: 24,p: 0 },{ n: 'ItemNetWeight',t: 16,p: 0 },{ n: 'PricingTypeID',t: 195,p: 100 },{ n: 'TaxableTypeID',t: 195,p: 100 },{ n: 'RateTypeID',t: 195,p: 100 },{ n: 'SeasonCodeID',t: 195,p: 100 },{ n: 'DayOfWeek',t: 201,p: 0 },{ n: 'DaysOfWeek',t: 15,p: 0 },{ n: 'TimeOfDayID',t: 195,p: 100 },{ n: 'WeightUnitsCodeID',t: 195,p: 100 },{ n: 'InventoryControlTypeID',t: 201,p: 0 },{ n: 'StorageControlID',t: 195,p: 100 },{ n: 'ItemControl',t: 15,p: 0 },{ n: 'IngredientsText',t: 21,p: 0 },{ n: 'UsageInstructions',t: 21,p: 0 },{ n: 'Calories',t: 16,p: 0 },{ n: 'StoreInventoryLocationID',t: 195,p: 100 },{ n: 'TotalReceivedQuantity',t: 16,p: 0 },{ n: 'TotalSoldQuantity',t: 16,p: 0 },{ n: 'TotalDisposedQuantity',t: 16,p: 0 },{ n: 'TotalLostQuantity',t: 16,p: 0 },{ n: 'AssociatedItemCount',t: 24,p: 0 },{ n: 'IsRecordActive',t: 22,p: 0 },{ n: 'HasOptions',t: 22,p: 0 },{ n: 'HasRelated',t: 22,p: 0 }];
//       Object Value Definition For StoreItems
const SIV = { 'StoreItemID': 0,'StoreLocationID': 0,'ReferenceItemID': 0,'AssociatedItemID': 0,'ItemName': '','ItemDescription': '','ItemFullDescription': '','ItemNote': '','ProductItemCategoryID': 0,'ProductItemGroupID': 0,'ProductItemTypeID': 0,'BrandID': 0,'UPCNumber': '','BarcodeNumber': '','ItemStatusID': 0,'PackagingTypeID': 0,'ItemSizeCodeID': 0,'TotalQuantity': 0,'TotalNetWeight': 0,'ReservedQuantity': 0,'LockedQuantity': 0,'AvailableQuantity': 0,'DocumentID': '','ImageID': '','ItemPrice': 0,'OverridePrice': 0,'PromotionPrice': 0,'Promotion2Price': 0,'PromotionType': 0,'StorePromotionID': 0,'ShelfLifeDays': 0,'ItemNetWeight': 0,'PricingTypeID': 0,'TaxableTypeID': 0,'RateTypeID': 0,'SeasonCodeID': 0,'DayOfWeek': 0,'DaysOfWeek': 0,'TimeOfDayID': 0,'WeightUnitsCodeID': 0,'InventoryControlTypeID': 0,'StorageControlID': 0,'ItemControl': 0,'IngredientsText': '','UsageInstructions': '','Calories': 0,'StoreInventoryLocationID': 0,'TotalReceivedQuantity': 0,'TotalSoldQuantity': 0,'TotalDisposedQuantity': 0,'TotalLostQuantity': 0,'AssociatedItemCount': 0,'IsRecordActive': false,'HasOptions': false,'HasRelated': false };
//------ Object Definition For CustomOrderItems -- Date: 2024-12-10-7:55 AM ------
const CustomOrderItemsOID = 545113;
const CustomOrderItemsO = [{ n: 'CustomOrderItemID',t: 195,p: 100 },{ n: 'CustomOrderID',t: 195,p: 100 },{ n: 'StoreItemID',t: 195,p: 100 },{ n: 'ReferenceID',t: 195,p: 100 },{ n: 'Quantity',t: 16,p: 0 },{ n: 'Weight',t: 16,p: 0 },{ n: 'Price',t: 28,p: 0 },{ n: 'OptionCount',t: 24,p: 0 },{ n: 'OptionsPrice',t: 28,p: 0 },{ n: 'TotalPrice',t: 28,p: 0 },{ n: 'TaxAmount',t: 28,p: 0 },{ n: 'Tax2Amount',t: 28,p: 0 },{ n: 'Tax3Amount',t: 28,p: 0 },{ n: 'DiscountAmount',t: 28,p: 0 },{ n: 'PromotionCount',t: 24,p: 0 },{ n: 'ReturnReason',t: 201,p: 0 },{ n: 'ReturnQuantity',t: 16,p: 0 },{ n: 'ReturnCycle',t: 24,p: 0 },{ n: 'OriginalQuantity',t: 16,p: 0 },{ n: 'OrderItemStatus',t: 201,p: 0 },{ n: 'SpecialInstruction',t: 21,p: 0 }];
//       Object Value Definition For CustomOrderItems
const COIV = { 'CustomOrderItemID': 0,'CustomOrderID': 0,'StoreItemID': 0,'ReferenceID': 0,'Quantity': 0,'Weight': 0,'Price': 0,'OptionCount': 0,'OptionsPrice': 0,'TotalPrice': 0,'TaxAmount': 0,'Tax2Amount': 0,'Tax3Amount': 0,'DiscountAmount': 0,'PromotionCount': 0,'ReturnReason': 0,'ReturnQuantity': 0,'ReturnCycle': 0,'OriginalQuantity': 0,'OrderItemStatus': 0,'SpecialInstruction': '' };
//       Object Index Definition For CustomOrderItems
const COIX = { 'CustomOrderItemID': 0,'CustomOrderID': 1,'StoreItemID': 2,'ReferenceID': 3,'Quantity': 4,'Weight': 5,'Price': 6,'OptionCount': 7,'OptionsPrice': 8,'TotalPrice': 9,'TaxAmount': 10,'Tax2Amount': 11,'Tax3Amount': 12,'DiscountAmount': 13,'PromotionCount': 14,'ReturnReason': 15,'ReturnQuantity': 16,'ReturnCycle': 17,'OriginalQuantity': 18,'OrderItemStatus': 19,'SpecialInstruction': 20 };

//------ Object Definition For ShoppingListItems -- Date: 2024-11-20-10:24 AM ------
const ShoppingListItemsOID = 547036;
const ShoppingListItemsO = [{ n: 'ShoppingListItemID',t: 195,p: 100 },{ n: 'ShoppingListID',t: 195,p: 100 },{ n: 'StoreItemID',t: 195,p: 100 },{ n: 'ItemName',t: 21,p: 0 },{ n: 'ItemDescription',t: 21,p: 0 },{ n: 'Quantity',t: 16,p: 0 },{ n: 'Weight',t: 16,p: 0 },{ n: 'ItemPrice',t: 28,p: 0 },{ n: 'CustomOrderID',t: 195,p: 100 },{ n: 'Active',t: 22,p: 0 },{ n: 'TotalPrice',t: 28,p: 0 },{ n: 'RateTypeID',t: 195,p: 100 }]; // Note - last 2 are added manually
//       Object Value Definition For ShoppingListItems
const SLIV = { 'ShoppingListItemID': 0,'ShoppingListID': 0,'StoreItemID': 0,'ItemName': '','ItemDescription': '','Quantity': 0,'Weight': 0,'ItemPrice': 0,'CustomOrderID': 0,'Active': false };
//       Object Index Definition For ShoppingListItems
const SLIX = { 'ShoppingListItemID': 0,'ShoppingListID': 1,'StoreItemID': 2,'ItemName': 3,'ItemDescription': 4,'Quantity': 5,'Weight': 6,'ItemPrice': 7,'CustomOrderID': 8,'Active': 9 };


//let ItemCategoriesDD = [];
//class CategoryDropDownCell extends React.Component {
//  handleChange = (e) => { // e.target.value is the object {ddID: n, ddName: 'n'}
//    //trace("change - field: " + this.props.field + "  value: " + JSON.stringify(e.target.value) + " dataitem: " + JSON.stringify(this.props.dataItem));
//    this.props.onChange({
//      dataItem: this.props.dataItem,
//      field: this.props.field,
//      syntheticEvent: e.syntheticEvent,
//      value: e.target.value
//    });
//    this.props.dataItem[this.props.field] = e.target.value.ddID;
//    this.forceUpdate();
//  }
//  render() {
//    let dataValue = this.props.dataItem[this.props.field];
//    if (dataValue === undefined || dataValue === null)
//      dataValue = 0;
//    if (!this.props.dataItem.inEdit) {
//      if (ItemCategoriesDD.find(c => c.ddID === dataValue) === undefined)
//        return (
//          <td>{"Unknown: " + dataValue}</td>
//        );
//      else
//        return (
//          <td>
//            {ItemCategoriesDD.find(c => c.ddID === dataValue).ddName}
//          </td>
//        );
//    }
//    return (
//      <td>
//        <DropDownList style={{ width: "100px" }} data={ItemCategoriesDD} textField="ddName" dataItemKey="ddID" value={ItemCategoriesDD.find(c => c.ddID === dataValue)} onChange={this.handleChange} />
//      </td>
//    );
//  }
//}     
//------------------------- List Template ------------------------------------------------------------------ 

const percentFormat = (value) => new Intl.NumberFormat('en-US',{ style: 'percent',minimumFractionDigits: 2,maximumFractionDigits: 2 }).format(value);
const moneyFormat = (value) => new Intl.NumberFormat('en-US',{ style: 'currency',currency: 'USD' }).format(value);
const dateFormat = (value) => new Intl.DateTimeFormat('en-CA',{ dateStyle: 'medium',timeStyle: 'short' }).format(Date.parse(value));


const StateContext = React.createContext([
  {
    TotalPrice: 0,
    ItemCount: 0,
    SubTotalPrice: 0,
    TotalTaxAmount: 0,
  },
  () => { },
]);
let useAlt = false;
let ItemDetailSecondLevel = false;

class ScannerPage extends Component {
  //------------------------------------------------------------------------------------------------------
  constructor(props) {
    super(props);
    //trace("ScannerPage");
    if (!SessionInfo.session || SessionInfo.session === '')
      this.props.navigate("/AppMain");
    else {
      this.createKeys = CreateKeys.bind(this);
    }
  }
  menuAnchor = React.createRef();
  itemNameAnchor = React.createRef();
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------  
  // State
  state = {
    CustomerID: 0,
    DeviceProfileID: 0,
    EmailReceipts: false,
    EmailPromotions: false,
    SMSReminders: false,
    SoundOn: false,
    AutoScanLocation: false,
    FullScreenReader: false,
    MaximumPurchaseAmount: 0,
    PersonPhotoID: 0,
    RoleID: 0,

    CustomOrderStatus: 0,
    OrderCreationDate: 0,
    OrderPaidDate: 0,
    AmountOwing: 0,
    ItemCount: 0,
    NetItemCount: 0,

    //--------------------------------
    CustomOrderID: 0,
    CustomOrderType: 0,
    TotalQuantity: 0,
    TotalNetWeight: 0,
    Price: 0,
    TotalPrice: 0,
    AmountPaid: 0,
    TotalAmount: 0,
    DiscountAmount: 0,
    CreditAmountUsed: 0,
    RefundAmount: 0,
    TipAmount: 0,
    TotalTaxAmount: 0,
    TotalTax2Amount: 0,
    TotalTax3Amount: 0,
    TotalDiscountAmount: 0,
    TotalCost: 0,
    TotalTime: 0,
    StartDateTime: 0,
    EndDateTime: 0,
    PaymentMethodID: 0,
    IndividualItems: 0,
    PaymentVerifiedID: 0,
    RateTypeID: 0,
    //--------------------------------
    // CustomerAccounts
    Amount: 0,
    TransactionCount: 0,
    MinusTransactions: 0,
    PlusTransactions: 0,
    TotalMinusAmount: 0,
    TotalPlusAmount: 0,
    MaximumAmount: 0,
    LastUsedOn: 0,
    CustomerAccountStatus: 0,
    //---- New ----   
    SubTotalPrice: 0,
    Quantity: 0,
    ItemName: '',
    total: 0,
    ShoppingListName: '',
    SLDescription: '',
    //--------------------------------   
    orderMessage: 'Most Recent Item Added and Quantity',

    itemChanged: false, // Note - this applies to multiple popups
    itemSaved: false,

    StoreName: 'Vancouver East',
    Address: '123 Main Street, Vancouver',
    FirstName: '',
    AdditionalName: '',
    LastName: '',
    EmailAddress: '',
    PhoneNumber: '',
    PhoneNumber2: '',

    selectedTopTab: 0,
    selectedBottomTab: 0,
    stateHasChanged: false,

    imgVideoVisible: false,
    showScan: true,
    result: 'No result',
    appDisplay: false,
    displayItemDetail: false,
    displayShoppingList: false,
    displayShoppingLists: false,
    showChangeItems: false,
    isItemChange: false,
    displaySLItem: false,
    displaySLQuick: false,
    showVerifyRemoveItem: false,
    showVerifyRemoveSLItem: false,
    showVerifyRemoveSL: false,
    delItemName: '',
    showBillSummary: false,
    RatingValue: 0,
    ServiceDescription: '',

    barcodeMessage: "Scan the Product Bar Code",

    ShoppingLists: [],
    ShoppingListItems: [],
    SLQuickItems: [],
    //------ Integer Values - ShoppingListItems ------
    ShoppingListItemID: 0,
    ShoppingListID: 0,
    StoreItemID: 0,
    Quantity: 0,
    Weight: 0,
    ItemPrice: 0,
    ItemPriceS: '',
    CustomOrderID: 0,
    Active: false,
    //------ String Values - ShoppingListItems ------
    ItemName: '',
    ItemDescription: '',

    SearchItems: [],
    OrderItems: [],
    orderItemsSkip: 0,
    orderItemsTake: 8,
    showStoreInfo: true,
    isMainSearch: true,
    searchValue: '',
    searchSLValue: '',
    searchSLItemValue: '',
    lastSearchValue: '',
    lastSearchSLValue: '',
    lastSearchSLItemValue: '',
    currentCustomerID: 0,
    //PersonPhoto: '',
    PersonPhotoURL: undefined,
    isWalletUser: false,
    contractsVisible: false,
    StoreLocationID: 0,
    selectCustomerID: 0,

    CustomOrders: [],
    customOrdersSkip: 0,
    customOrdersTake: 8,
    receiptFilter: { logic: "and",filters: [] },
    receiptSort: [],

    Customers: [],
    customersSkip: 0,
    customersTake: 18,
    inAddSLList: false,
    inEditSLList: false,

    Roles: [],
    CustomerAccountStatusInfo: [],
    CreditAmount: 0,

    HoursForToday: '',
    showMenu: false,
    showNotify: false,

    DocumentTypes: [{ ddName: "jpg",ddID: 1 },{ ddName: "jpeg",ddID: 2 },{ ddName: "png",ddID: 3 }],
  };
  vertSplitC = JSON.parse('[{"collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"min":"300px"},{"collapsible":true,"collapsed":true,"resizable":true,"scrollable":true,"size":"50%"}]');
  vertSplitO = JSON.parse('[{"collapsible":false,"collapsed":false,"resizable":true,"scrollable":true,"min":"300px"},{"collapsible":true,"collapsed":false,"resizable":true,"scrollable":true,"size":"50%"}]');

  inAShopping = false;
  backPrompt = '< Back to Locations';
  inputReference = React.createRef();
  createKeys;
  loadExistingPage = false;
  lastSelectedPID = 0;
  barcodeReader = undefined;
  selectedDeviceId = undefined;
  barcode = '';
  notifyTimer = 0;
  menuKeep = false;
  comp2Update = false;
  saveOrderItems = [];
  itemChangeOffset = { left: 20,top: 65 };
  billPopupOffset = { left: 15,top: 20 };
  changeRowIdx = 0;
  inAddOrderItem = false;
  editSLItem = false;
  backScannerPrompt = '< Back to Scanner';
  backAddItem = '< Back to Add Item';
  backSListPrompt = '< Back to Lists';
  useSListPrompt = 'Use Shopping List >';
  useSLQuickPrompt = 'Quick Entry >';
  useSLDetailPrompt = 'Detail Entry >';
  backSLItemPrompt = '< Back to Shopping List';

  imageHeight = 230; // Standard height for the image - does not change
  detailHeaderHeight = 0;
  descAdjust = 0;
  listHeight = 0;
  popupHeight = 0; // The height of the item desc popup
  addNewItem = false; // Add/Edit New or Existing Item
  billTimer = 0;
  NetItemCount = 0;

  CustomOrderItemID = 0;
  ShoppingListID = 0;
  ShoppingListItemID = 0;
  saveShoppingLists = [];
  saveShoppingListItems = [];
  deleteItem = [];
  scanData = "";
  scanCounter = 0; // Count down to next scan on continuous scan mode
  scanWeight = false;
  scanBorder = "#504B5C";
  scanItemB = "#504B5C";
  scanWeightB = "#68DA68";
  listItemSLBG = "#DFDBDB";
  listNameOnlyBG = "#CECECE";
  saveImage = undefined;
  baseHT = 148;
  specHT = 0;
  dispHT = 0;
  msgHT = 0;
  currentScanHT = 0;
  SLOffset = { left: 50,top: 70 };
  //activeColor = "#3e80ed";
  //inactiveColor = "#BBBDC7";
  //okColor = "#00FF00";

  async componentDidMount() {
    if (!SessionInfo.session || SessionInfo.session === '')
      return;
    trace(`----> Scanner Page Mount - existing: ${this.loadExistingPage}, reset: ${SessionInfo.ResetOrder}, Domain: ${SessionInfo.DomainName}`);
    trace(`      Width: ${SessionInfo.Width}, Height: ${SessionInfo.Height}, userID: ${SessionInfo.OMUserID},  personID: ${SessionInfo.PersonInfo.CustomerID}, OrderID: ${SessionInfo.CustomOrderID}, StoreLocationID: ${SessionInfo.StoreLocationID} `);
    SessionInfo.currentPage = "ScannerPage";
    this.setState({ showMenu: false });
    if (SessionInfo.DomainName.indexOf('localhost') >= 0) {
      scanHT = 230;
      scanWD = 300;
      scannerHT = 0; // scanHT + 40;
    }
    else {
      scanHT = 280;
      scanWD = 240;
      scannerHT = 0; // scanHT + 40;
    }
    trace(`Initialized - height: ${scannerHT}, HT: ${scanHT}, WD: ${scanWD}, Reset: ${SessionInfo.ResetOrder}, CustomOrderID: ${SessionInfo.CustomOrderID}, CurrentPaidCustomOrderID: ${SessionInfo.CurrentPaidCustomOrderID}`);
    document.documentElement.style.setProperty('--scan-height',`${scannerHT}px`);
    document.documentElement.style.setProperty('--scanHT',`${scanHT + 10}px`);
    document.documentElement.style.setProperty('--scanWD',`${scanWD + 10}px`);
    if (SessionInfo.ResetOrder === true) {
      SessionInfo.ResetOrder = false;
      SessionInfo.CustomOrderID = 0;
      this.setState({ CustomOrderID: 0 });
      this.setState({ OrderItems: [] });
      this.setState({ SubTotalPrice: 0 });
      this.setState({ TotalTaxAmount: 0 });
      this.setState({ TotalPrice: 0 });
      if (SessionInfo.CurrentPaidCustomOrderID > 0) { // Order is complete
        SessionInfo.BillPaymentDone = true;
        SessionInfo.BillPaymentComplete = true;
        SessionInfo.firstOrderComplete = true;
        SessionInfo.CurrentPaidCustomOrderID = 0;
        await this.resetOrder();
      } else
        this.closePopups(1);
      this.forceUpdate();
    }
    else {
      if (this.loadExistingPage === true) {
        this.forceUpdate();
        this.closePopups(1);
      } else {
        trace(`Load CustomOrderID: ${SessionInfo.CustomOrderID}, CurrentCustomOrderID: ${SessionInfo.CurrentPaidCustomOrderID}`);
        let CD = await CallOM("GetCustomOrderIDActive",0,SessionInfo.CurrentPaidCustomOrderID,0);
        trace(`-> ScannerPage - GetCustomOrderIDActive CD: ${JSON.stringify(CD)}, SessionInfo.CustomOrderID: ${SessionInfo.CustomOrderID}`);
        if (CD.d && CD.d !== 0) {
          SessionInfo.CustomOrderID = CD.d; // Note - CustomOrderID is also in CD.x.t set from ActiveMOID
          //SessionInfo.OrderType = CD.x.p; // p is not coming through from ActiveParm2
          SessionInfo.OrderType = CD.x.k;  // Set from ActiveKey
          if (SessionInfo.CustomOrderID > 0) {
            this.setState({ selectCustomerID: SessionInfo.PersonInfo.CustomerID });
            SessionInfo.CurrentOrderCustomerID = SessionInfo.PersonInfo.CustomerID;
            this.lastSelectedPID = SessionInfo.PersonInfo.CustomerID;
            // Check for completed Order
            trace(`Status: ${CD.d.Status}, Seat: ${CD.d.SeatName}, Count: ${CD.d.SeatCount}`)
            //trace(`CD.d: ${JSON.stringify(CD.d)}`);
            this.setState({ StoreName: CD.d.LocationName });
            if (CD.d.Status >= 10) { // Order is complete
              SessionInfo.BillPaymentDone = true;
              SessionInfo.BillPaymentComplete = true;
              SessionInfo.firstOrderComplete = true;
              SessionInfo.CurrentPaidCustomOrderID = 0;
              await this.resetOrder();
            }
            else
              this.closePopups(1);
          }
          else
            this.closePopups(1);
        }
        else
          this.closePopups(1);
      }
      await this.getOrderItemRecords();
      await this.getCurrentTotal();
    }
    //-------------------------------------------------------------  
    if (SessionInfo.HoursForToday === '') {
      try {
        let CD = await CallOM("GetStoreHoursOfOperationForToday",0,SessionInfo.StoreLocationID,0);
        SessionInfo.HoursForToday = CD.d.toString();
      }
      catch (Ex) {
        await OMTrace(2,`Failure in GetStoreHoursOfOperationForToday - Error: ${Ex}`);
      }
      trace(`Hours For Today: ${SessionInfo.HoursForToday}`);
      await this.setState({ HoursForToday: SessionInfo.HoursForToday });
    }
    this.showLocationHours();
    this.setState({ imgVideoVisible: false });
    this.setState({ showScan: true });
    this.runMonitorProcess = true;
    this.monitorProcess();
  }
  componentWillUnmount() {
    this.onCancelScan();
    if (SessionInfo.session !== '')
      SessionInfo.ScannerPage = this.state;
    this.runMonitorProcess = false;
    if (this.timeout)
      clearTimeout(this.timeout);
  }
  signIn = async () => {
    trace(`logontype: ${SessionInfo.appEntityLogonType}`);
    if (SessionInfo.appEntityLogonType === 1) {
      SessionInfo.isPhoneLogin = false;
    } else if (SessionInfo.appEntityLogonType === 8) {
      SessionInfo.isPhoneLogin = true;
      SessionInfo.hasPhoneLogin = true;
    }
    SessionInfo.logonReturn = 1;
    SessionInfo.PersonInfo.FirstName = undefined;
    this.props.navigate(`/Login`);
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Barcode
  //initBarcode() {
  //  //trace("init barcode");
  //  //window.addEventListener('load', function () {
  //  trace('ZXing code reader initialized');
  //  this.barcodeReader.getVideoInputDevices()
  //    .then((videoInputDevices) => {
  //      //const sourceSelect = document.getElementById('sourceSelect');
  //      //trace(`Input Devices: ${videoInputDevices.length}`);
  //      trace(`Input Devices: ${JSON.stringify(videoInputDevices)}`);
  //      OMTrace(1, `Input Devices: ${JSON.stringify(videoInputDevices)}`);
  //      displayMessage(`Input Devices: ${videoInputDevices.length}`);
  //      this.selectedDeviceId = videoInputDevices[0].deviceId
  //      if (videoInputDevices.length > 1) {
  //        videoInputDevices.forEach((element) => {
  //          const sourceOption = document.createElement('option')
  //          sourceOption.text = element.label
  //          sourceOption.value = element.deviceId
  //          //sourceSelect.appendChild(sourceOption)
  //        })
  //        if (videoInputDevices[1]) {
  //          this.selectedDeviceId = videoInputDevices[1].deviceId
  //        }
  //        //sourceSelect.onchange = () => {
  //        //  this.selectedDeviceId = sourceSelect.value;
  //        //}
  //        //const sourceSelectPanel = document.getElementById('sourceSelectPanel')
  //        //sourceSelectPanel.style.display = 'block'
  //      }

  //      //trace(`Add Click Event`);
  //      //document.getElementById('scanButton').addEventListener('click', () => {
  //      //  trace("Start Decode device: " + selectedDeviceId);
  //      //  this.setState({ imgVideoVisible: 'false' });
  //      //  displayMessage("Start Decode  device: " + selectedDeviceId);
  //      //  codeReader.decodeOnceFromVideoDevice(selectedDeviceId, 'scannerVideo').then((result) => {
  //      //    trace(result);
  //      //    this.barcode = result.text;
  //      //    document.getElementById('result').textContent = result.text;
  //      //    codeReader.reset();
  //      //    this.finishScan();
  //      //  }).catch((err) => {
  //      //    console.error("Barcode Listener: " + err);
  //      //    document.getElementById('result').textContent = err;
  //      //  })
  //      //  trace(`Started continuous decode from camera with id ${selectedDeviceId}`)
  //      //})

  //      //document.getElementById('resetButton').addEventListener('click', () => {
  //      //  trace("Reset Decode");
  //      //  document.getElementById('result').textContent = '';
  //      //  this.barcodeReader.reset();
  //      //  trace('Reset.')
  //      //})

  //    })
  //    .catch((err) => {
  //      console.error("addEventListener: " + err)
  //    })
  //  //})
  //}
  onOrder = () => {
    this.props.navigate("/OrderPage");
  }
  startScan = () => {
    trace(`ZXing code reader initialized - height: ${scannerHT}, HT: ${scanHT}, WD: ${scanWD}`);
    scannerHT = scanHT + 40;
    document.documentElement.style.setProperty('--scan-height',`${scannerHT}px`);
    this.setState({ imgVideoVisible: true });
    this.setState({ showScan: false });
    this.currentScanHT = scannerHT;
    let HHT = this.baseHT + this.specHT + this.dispHT + this.msgHT + this.currentScanHT;
    document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
    window.scrollTo(0,0);
    codeReader.decodeFromInputVideoDevice(undefined,'scannerVideo').then(this.handleScan).catch(this.handleError);
    //codeReader.decodeFromInputVideoDevice(undefined,'scannerVideo').then(stream => this.handleScan).catch(this.handleError);
    //codeReader.stream.getVideoTracks()[0].applyContraints({ advanced: [{ torch: true }] });
  };
  handleScan = async (data) => {
    trace(`handleScan: ${data}, scanCounter: ${this.scanCounter}`);
    codeReader.reset();
    if (this.scanCounter == 0) {
      if (data) {
        let keyInfo = data.toString();
        this.setState({ scannedString: keyInfo });
        trace(`Scanned Data: ${keyInfo}`);
        try {
          if (hideScannerAfterScan === true) // After a successful scan - close the scanner
            this.hideScanner();
          else // If continous scan - wait for the next item to be scanned
            this.scanCounter = 10;
          await this.getAddOrderItemRecord(keyInfo); // Add the item to the Order - or add the weight to the item
          await this.getCurrentTotal();
          //codeReader.decodeFromInputVideoDevice(undefined,'scannerVideo').then(this.handleScan).catch(this.handleError);
        } catch (error) {
          await OMTrace(2,`Failure handleScan - Error: ${error}`);
        }
      }
    }
    else {
      codeReader.decodeFromInputVideoDevice(undefined,'scannerVideo').then(this.handleScan).catch(this.handleError);
    }
  };
  handleError = (err) => {
    console.log(`Scan Error`);
    //console.error(err);
  };
  onCancelScan = async () => {
    trace("Cancel Scan - Reset Decode");
    this.hideScanner();
    // The following is for testing
    if (SessionInfo.debug === true && 1 === 0) {
      if (this.scanWeight === true) {
        trace(`Add weight`)
        await this.getAddOrderItemRecord("450"); // Add the weight to the item
        await this.getCurrentTotal();
      }
      else {
        //await this.addOrderItem('11020200011');
        await this.getAddOrderItemRecord("11030200002"); // Add the weight to the item
        await this.getCurrentTotal();
      }
    }
  }
  hideScanner = () => {
    document.documentElement.style.setProperty('--scan-height','0px');
    if (codeReader)
      codeReader.reset();
    this.setState({ imgVideoVisible: false });
    this.setState({ showScan: true });
    this.currentScanHT = 0;
    let HHT = this.baseHT + this.specHT + this.dispHT + this.msgHT + this.currentScanHT;
    document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
  }
  //----------------------------------
  runMonitorProcess = false;
  setTimer() {
    if (SessionInfo.loggedOn === true && this.runMonitorProcess === true)
      this.timeout = setTimeout(this.monitorProcess.bind(this),200); // 200 microseconds  
  }
  //----- Timer Process - Application Control Logic -------------------------------------------------
  monitorProcess = async (force) => { // Note - Monitor only runs if logged on
    if (force)
      this.runMonitorProcess = true;
    //trace(`monitor logoff: ${SessionInfo.forceLogoff}, On: ${SessionInfo.loggedOn}`); 
    if (SessionInfo.forceLogoff === true) {
      SessionInfo.forceLogoff = false;
      this.props.navigate("/Login");
    }
    if (this.runMonitorProcess === true && SessionInfo.loggedOn === true) {
      this.setTimer();
      if (1 === 1 || document.hasFocus() === true) { // Execute monitor process
        //---- Ping and Notification Processing -------------
        //trace(`Notify: ${SessionInfo.setShowNotify}`);
        if (SessionInfo.setShowNotify > 0 && SessionInfo.notifyMessage.length > 0) {
          this.setState({ notifyMessage: SessionInfo.notifyMessage });
          SessionInfo.notifyTimer = SessionInfo.notifyTime;
          this.setNotifyMessage(true); // Show the Message 
          //this.setState({ showNotify: true }); // Show the Message 
          if (SessionInfo.notifyRing && (SessionInfo.SoundOn === true || SessionInfo.SoundOverride === true)) {
            //trace(`Play Notify Sound: ${SessionInfo.notifyRing}`);
            try {
              await SessionInfo.notifyRing.play();
            }
            catch (Ex) {
              trace(`Ring Ex: ${Ex}`);
            }
            SessionInfo.notifyRing = undefined;
            SessionInfo.SoundOverride = false;
          }
        }
        SessionInfo.setShowNotify = 0;
        if (SessionInfo.notifyTimer > 0) {
          if (--SessionInfo.notifyTimer <= 0)
            this.setNotifyMessage(false); // Hide the Notify Message
        } else if (SessionInfo.showNotify === true)
          this.setNotifyMessage(false); // Hide the Notify Message
        if (SessionInfo.pingCounter++ > 50) {
          SessionInfo.pingCounter = 0;
          await PingApp();
        }
      }
      if (this.scanCounter > 0) {
        this.scanCounter--;
        if (this.scanCounter == 0) {
          codeReader.decodeFromInputVideoDevice(undefined,'scannerVideo').then(this.handleScan).catch(this.handleError);
        }
      }
      if (this.billTimer > 0) {
        this.billTimer--;
      } else if (this.state.showBillSummary === true) {
        //this.setState({ showBillSummary: false }); // Hide the Bill Summary
        this.doneComment();
      }
      //---- End of Notification Processing -------------
    }
  }
  setNotifyMessage = (setOn) => {
    if (setOn === true) {
      this.setState({ showNotify: true });
      this.msgHT = 80;
    } else {
      this.setState({ showNotify: false });
      this.msgHT = 0;
    }
    document.documentElement.style.setProperty('--header-msg-ht',this.msgHT + 'px');
    let HHT = this.baseHT + this.specHT + this.dispHT + this.msgHT + this.currentScanHT;
    document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
  }
  ClearMessage = async () => { // ClearDisplay, Clear Messages
    //trace("ClearMessage Pressed - for: " + SessionInfo.currentPage);
    this.setState({ MessagesValue: '' });
    SessionInfo.message = ''; // MessagesValue is set to SessionInfo.message in the Timer loop
    SessionInfo.acknowledge = false;
    this.setNotifyMessage(false);
  }
  acknowledgeMessage = async () => {
    let CD = await CallOM("AcknowledgeNotification",0,SessionInfo.AppNotificationID);
    this.setNotifyMessage(false); // Hide the Notify Message
    SessionInfo.notifyTimer = 50;
    SessionInfo.acknowledge = false;
    this.forceUpdate();
  }
  showLocationHours = () => {
    this.setState({ HoursForToday: SessionInfo.HoursForToday });
    //console.trace("Show Store Info"); // This is VERY Different -- console.trace ---
    this.setState({ showStoreInfo: true });
    this.dispHT = 70;
    document.documentElement.style.setProperty('--header-disp-ht',this.dispHT + 'px');
    let HHT = this.baseHT + this.specHT + this.dispHT + this.msgHT + this.currentScanHT;
    document.documentElement.style.setProperty('--HeadingHeight',HHT + 'px');
  }
  // Test implementation
  //shouldComponentUpdate(nextProps, nextState) {
  //  return !equals(nextProps, this.props); // equals() is your implementation
  //}
  //handleScan(data) {
  //  this.setState({
  //    result: data,
  //  })
  //}
  //handleError(err) {
  //  console.error(err)
  //}
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------  
  CommandCell;
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  OrderHeader = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewHeader className='listOrderHeader'>
        <div className='listHeaderLeft'>
          <span style={{ fontSize: 'large' }}>Total &nbsp;&nbsp;&nbsp;</span>
          <span style={{ fontSize: 'large',fontWeight: 'bold' }}>{moneyFormat(this.state.TotalPrice)}</span>
          <br style={{ lineHeight: '2px',fontSize: 'small' }} />
          {this.state.NetItemCount === 0 ?
            <span style={{ left: '210px',fontSize: 'medium' }}>No Items Yet</span> : null}
          {this.state.NetItemCount === 1 ?
            <span style={{ left: '210px',fontSize: 'medium' }}>1 Item Selected</span> : null}
          {this.state.NetItemCount > 1 ?
            <span style={{ left: '210px',fontSize: 'medium' }}>{this.state.NetItemCount} Items</span> : null}
          {/*{this.state.TotalQuantity > this.state.NetItemCount ?*/}
          {/*  <span style={{ fontSize: 'medium' }}>&nbsp;({this.state.TotalQuantity})</span> : null}*/}
          <span></span>
        </div>
        <div className='listHeaderRight'>
          <Button id="checkoutButton" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} >&nbsp;Checkout &nbsp;</Button>
        </div>
      </ListViewHeader>
    );
  }
  //OrderItemFormat = props => {
  //  let item = props.dataItem;
  //  if (!item.imageVal) {
  //    let value = item.Image;
  //    if (!value) { // Note - blank
  //      value = "/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAZABkDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD32iiigAooooAKKKKACiiigD//2Q==";
  //    }
  //    const byteCharacters = atob(value);
  //    const byteNumbers = new Array(byteCharacters.length);
  //    for (let i = 0; i < byteCharacters.length; i++) {
  //      byteNumbers[i] = byteCharacters.charCodeAt(i);
  //    }
  //    const byteArray = new Uint8Array(byteNumbers);
  //    let image = new Blob([byteArray],{ type: 'image/jpeg' });
  //    item.imageVal = URL.createObjectURL(image);
  //  }
  //  return (
  //    <div className="listRow">
  //      <div className="listCol1">
  //        <span style={{ fontSize: 16,color: "black" }} >{item.ItemName}</span><br />
  //        <span style={{ fontSize: 12,color: "black" }} >{item.ItemDescription}</span>
  //      </div>
  //      <div className="listColR">
  //        <div className="listCol2">
  //          <span style={{ fontSize: 16,color: "black" }} >{moneyFormat(item.Price)}</span> <br />
  //          {/*  <span style={{ fontSize: 12, color: "black" }} >{item.BarcodeNumber}</span>*/}
  //        </div>
  //        <div className="listOMImageDiv1">
  //          <Avatar rounded='large' size='large' type='image' style={{ height: '76px',width: '76px',}}>
  //            <img src={item.imageVal} alt='' style={{ height: '76px',width: '76px',}} title={`${item.ItemName}`} />
  //          </Avatar>
  //        </div>
  //        <div className="listCol5">
  //          {/*  <img src={require("./images/delete.svg")} alt="" id="GridRefresh" title="Delete the current entry" className="functionImage" onClick={(e) => window.confirm(`Delete ${item.ItemName.trimRight()}?`) && this.onDeleteItem(item)} /> */}
  //          <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="functionImage" onClick={(e) => window.confirm(`Delete ${item.ItemName.trimRight()}?`) && this.onDeleteItem(item)} />
  //        </div>
  //      </div>
  //    </div>
  //  );
  //}          
  OrderItemFormat = props => {
    let rowIdx = props.index;
    let item = props.dataItem;
    //trace(`OrderItemFormat - item: ${JSON.stringify(item)}`);
    if (!item.imageVal) { // If the Item does not have imageVal (URL) it will take the Image and convert it to a URL
      let value = item.Image;
      if (!value) { // No Image
        if (!item.imageID) // No Image - set to blank
          value = "/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAZABkDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD32iiigAooooAKKKKACiiigD//2Q==";
        //  else { - NOTE - Can't await
        //    value = await this.GetItemImage(item.imageID);
        //  }
      }
      const byteCharacters = atob(value);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let image = new Blob([byteArray],{ type: 'image/jpeg' });
      item.imageVal = URL.createObjectURL(image);
    }

    return (
      <div>
        <div className="listScanRow" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listScanText">
            <span className="listScanItemName">{item.ItemName}&nbsp;&nbsp;
            </span><br />
            <p className="listScanItemDesc">{item.ItemDescription}</p>
          </div>
          <div className="listScanBuyDiv">
            <div className="listScanPriceTotal">
              {item.RateDesc != '' ?
                <>
                  <span>{moneyFormat(item.Price)}</span> <br style={{ lineHeight: '0px',}} />
                  <span className="listScanWht">{item.Weight} grams</span>
                </>
                :
                <>
                  <span>{moneyFormat(item.Price)}</span> <br style={{ lineHeight: '0px',}} />
                  <span className="listScanCount" > &nbsp; x {item.Quantity}</span>
                </>}
              <span className="listScanTotal" >{moneyFormat(item.TotalPrice)} &nbsp;</span>
              {SessionInfo.AC.HasShoppingCart ?
                <div className="listScanEditDelete">
                  {this.state.searchForItems ?
                    <>
                      <CartAdd alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.addStoreItem(e,item,rowIdx)} />
                    </>
                    :
                    <>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="listScanBtn2" onClick={(e) => this.verifyRemoveSL(e,item)} />
                      {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                        <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML1" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                    </>}
                </div> : null}
            </div>
            <div className="listScanImage">
              <Avatar rounded='large' size='large' type='image' className='avatarOrderPic'>
                <img src={item.imageVal} alt='' className='listOrderMenuColImage' title={`${item.ItemName}`} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)} ref={this.detailAnchor} />
              </Avatar>
            </div>
          </div>
        </div>
      </div>
    );
  }
  OrderItemFormatAlt = props => {
    let item = props.dataItem;
    if (!item.imageVal) {
      let value = item.Image;
      if (!value) { // Note - blank
        value = "/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAZABkDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD32iiigAooooAKKKKACiiigD//2Q==";
      }
      const byteCharacters = atob(value);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let image = new Blob([byteArray],{ type: 'image/jpeg' });
      item.imageVal = URL.createObjectURL(image);
    }
    //let item = props.dataItem;
    //let imageVal = undefined;
    //if (item["Image"]) {
    //  let value = item["Image"];
    //  //trace("ImageCell value: " + value);
    //  const byteCharacters = atob(value);
    //  const byteNumbers = new Array(byteCharacters.length);
    //  for (let i = 0; i < byteCharacters.length; i++) {
    //    byteNumbers[i] = byteCharacters.charCodeAt(i);
    //  }
    //  const byteArray = new Uint8Array(byteNumbers);
    //  let image = new Blob([byteArray], { type: 'image/jpeg' });
    //  //trace("image: " + JSON.stringify(image));
    //  imageVal = URL.createObjectURL(image);
    //}
    return (
      <div className="listScanRow">
        <div className="listCol1">
          <span style={{ fontSize: 16,color: "black" }} >{item.ItemName}</span><br />
          <span style={{ fontSize: 12,color: "black" }} >{item.ItemDescription}</span>
        </div>
        <div className="listColR">
          <div className="listCol2">
            <span style={{ fontSize: 16,color: "black" }} >{moneyFormat(item.Price)}</span> <br />
            {/*  <span style={{ fontSize: 12, color: "black" }} >{item.BarcodeNumber}</span>*/}
          </div>
          <div className="listOMImageDiv1">
            <Avatar rounded='large' size='large' type='image' style={{ height: '76px',width: '76px',}}>
              <img src={item.imageVal} alt='' style={{ height: '76px',width: '76px',}} title={`${item.ItemName}`} />
            </Avatar>
          </div>
          <div className="listCol5">
            {/*  <img src={require("./images/delete.svg")} alt="" id="GridRefresh" title="Delete the current entry" className="functionImage" onClick={(e) => window.confirm(`Delete ${item.ItemName.trimRight()}?`) && this.onDeleteItem(item)} /> */}
            <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="functionImage" onClick={(e) => this.verifyRemoveItem(e,item)} />
          </div>
        </div>
      </div>
    );
  }
  // style={{ border: 'solid',borderWidth: '2px',borderColor: 'red' }}
  OrderItemFormatNP = props => {  // Format No Picture
    let rowIdx = 1; // props.index;
    let item = props.dataItem;
    //trace(`OrderItem Format - item: ${JSON.stringify(item)}`);    
    item.RateDesc = '';

    return (
      <div>
        {item.OrderItemStatus <= 0 ?
          <div >  {/* This is an SL Item with a StoreItem - otherwise the orderitemstatus is set to -1 by the OM */}
            {item.OrderItemStatus === 0 ?
              <div className="listScanRow" style={{ background: this.listItemSLBG }} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>  {/* StoreItem with Pending - from SL */}
                <div className="listSLSText">
                  <span className="listScanItemName">{item.ItemName}
                  </span><br />
                  <p className="listScanItemDesc">{item.ItemDescription}</p>
                </div>
                <div className="listSLBuyDiv">
                  {item.RateTypeID > 1 ?
                    <>
                      <span>{moneyFormat(item.Price)}</span> <br style={{ lineHeight: '0px',}} />
                      <span className="listScanWht">{item.Weight} grams</span>
                    </>
                    :
                    <>
                      <span>{moneyFormat(item.Price)}</span> <br style={{ lineHeight: '0px',}} />
                      {item.Quantity > 1 ?
                        <span className="listScanCountB" > &nbsp; x {item.Quantity}</span> : null}
                    </>}
                  {item.TotalPrice > 0 && item.Quantity > 1 ?
                    <span className="listScanTotal" >{moneyFormat(item.TotalPrice)} &nbsp;</span> : null}
                  <div className="listScanEditDelete">
                    {this.state.searchForItems ?
                      <>
                        <CartAdd alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.addStoreItem(e,item,rowIdx)} />
                      </>
                      :
                      <>
                        <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.verifyRemoveItem(e,item)} />
                      </>}
                  </div>
                </div>
              </div>
              :
              <div className="listScanRowName" style={{ background: this.listNameOnlyBG }} onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}> {/* Name and Desc Only - from SL */}
                <div className="listSLSText">
                  <span className="listScanItemName">{item.ItemName}
                  </span><br />
                  <p className="listScanItemDesc">{item.ItemDescription}</p>
                </div>
                <div className="listScanEditDelete">
                  {this.state.searchForItems ?
                    <>
                      <CartAdd alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn2" onClick={(e) => this.addStoreItem(e,item,rowIdx)} />
                    </>
                    :
                    <>
                      <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="listScanBtn2" onClick={(e) => this.verifyRemoveItem(e,item)} />
                    </>}
                </div>
              </div>}
          </div>
          :
          <div >  {/* An Actual Scanned Item with Status > 0 */}
            <div className="listScanRow"> {/*onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>*/}
              <div className="listSLSText">
                <span className="listScanItemName">{item.ItemName}
                </span><br />
                <p className="listScanItemDesc">{item.ItemDescription}</p>
              </div>
              <div className="listSLBuyDiv">
                {item.RateTypeID > 1 ?
                  <>
                    <span>{moneyFormat(item.Price)}</span> <br style={{ lineHeight: '0px',}} />
                    <span className="listScanWht">{item.Weight} grams</span>
                  </>
                  :
                  <>
                    <span>{moneyFormat(item.Price)}</span> <br style={{ lineHeight: '0px',}} />
                    <span className="listScanCount" > &nbsp; x {item.Quantity}</span>
                  </>}
                {item.TotalPrice > 0 ?
                  <span className="listScanTotal" >{moneyFormat(item.TotalPrice)} &nbsp;</span> : null}
                <div className="listScanEditDelete">
                  {this.state.searchForItems ?
                    <>
                      <CartAdd alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.addStoreItem(e,item,rowIdx)} />
                    </>
                    :
                    <>
                      <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn3" onClick={(e) => this.choiceForItem(e,item,rowIdx)} />
                      <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="listScanBtn2" onClick={(e) => this.verifyRemoveItem(e,item)} />
                      {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                        <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML1" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                    </>}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
  verifyRemoveItem = (evt,item) => {
    evt.stopPropagation(); 
    if (item.ItemStatusID > 0) {            
      this.deleteItem = item;
      trace(`verify remove Item: ${JSON.stringify(this.deleteItem)}`);
      this.setState({ showVerifyRemoveItem: true }); 
    } else {
      this.onDeleteItem(item);
    }
  }
  verifiedRemoveItem = (evt) => {
    evt.stopPropagation();
    trace(`remove Item: ${JSON.stringify(this.deleteItem)}`);
    this.setState({ showVerifyRemoveItem: false });
    this.onDeleteItem(this.deleteItem)
  }
  cancelRemoveItem = (evt) => {
    evt.stopPropagation();
    this.setState({ showVerifyRemoveItem: false });
  }
  //----------------
  verifyRemoveSLItem = (evt,item) => {
    evt.stopPropagation();
    trace(`verify remove SL Item: ${JSON.stringify(this.deleteItem)}`); 
    this.deleteItem = item;
    if (item.StoreItemID == 0)
      this.onDeleteSLItem(this.deleteItem);
    else
      this.setState({ showVerifyRemoveSLItem: true });
  }
  verifiedRemoveSLItem = (evt) => {
    evt.stopPropagation();
    trace(`remove Item: ${JSON.stringify(this.deleteItem)}`);
    this.setState({ showVerifyRemoveSLItem: false });
    this.onDeleteSLItem(this.deleteItem)
  }
  cancelRemoveSLItem = (evt) => {
    evt.stopPropagation();
    this.setState({ showVerifyRemoveSLItem: false });
  }
  //----------------
  verifyRemoveSL = (evt,item) => {
    evt.stopPropagation();
    trace(`verify remove SL ${JSON.stringify(this.deleteItem)}`);
    this.deleteItem = item;
    this.setState({ showVerifyRemoveSL: true });
  }
  verifiedRemoveSL = (evt) => {
    evt.stopPropagation();
    trace(`remove SL ${JSON.stringify(this.deleteItem)}`);
    this.setState({ showVerifyRemoveSL: false });
    this.onDeleteShoppingList(this.deleteItem)
  }
  cancelRemoveSL = (evt) => {
    evt.stopPropagation();
    this.setState({ showVerifyRemoveSL: false });
  }
  removeSLQuickItem = (evt,item) => {
    this.setState({
      SLQuickItems: this.state.SLQuickItems.filter(e => e.ItemName !== item.ItemName)
    });
  }
  //lastCategory = "";
  //OrderItemFormat = props => {
  //  let item = props.dataItem;
  //  if (!item.imageVal) {
  //    let value = item.Image;
  //    if (!value) { // Note - blank
  //      value = "/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAZABkDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD32iiigAooooAKKKKACiiigD//2Q==";
  //    }
  //    const byteCharacters = atob(value);
  //    const byteNumbers = new Array(byteCharacters.length);
  //    for (let i = 0; i < byteCharacters.length; i++) {
  //      byteNumbers[i] = byteCharacters.charCodeAt(i);
  //    }
  //    const byteArray = new Uint8Array(byteNumbers);
  //    let image = new Blob([byteArray], { type: 'image/jpeg' });
  //    item.imageVal = URL.createObjectURL(image);
  //  }
  //  let showCategory = false;
  //  let categoryName = '';
  //  let categoryDesc = '';
  //  let categoryImage = undefined;
  //  //trace(`CategoryID: ${item.ProductItemCategoryID}`);
  //  //if (item.ProductItemCategoryID !== this.lastCategory) {
  //  //  showCategory = true;
  //  //  let ix = this.state.Categories.findIndex(cat => cat.ProductItemCategoryID === item.ProductItemCategoryID);
  //  //  categoryName = this.state.Categories[ix].ProductItemCategory;
  //  //  categoryDesc = this.state.Categories[ix].Description;
  //  //  this.lastCategory = item.ProductItemCategoryID;
  //  //  // Image
  //  //  const byteCharacters = atob(this.state.Categories[ix].ImageID);
  //  //  const byteNumbers = new Array(byteCharacters.length);
  //  //  for (let i = 0; i < byteCharacters.length; i++) {
  //  //    byteNumbers[i] = byteCharacters.charCodeAt(i);
  //  //  }
  //  //  const byteArray = new Uint8Array(byteNumbers);
  //  //  let imageVal = new Blob([byteArray], { type: 'image/jpeg' });
  //  //  categoryImage = URL.createObjectURL(imageVal);
  //  //}

  //  return (
  //    <div>
  //      {showCategory === true ?
  //        <div style={{ fontSize: 18, color: "black", fontWeight: "bold", backgroundColor: "linen", height: '74px', width: '100%' }}>
  //          <div className="listOMCatL">
  //            <Avatar rounded='large' size='large' type='image' style={{ height: '74px', width: '74px', marginLeft: '18px' }}>
  //              <img src={categoryImage} alt='' style={{ height: '74px', width: '74px', }} title={`${categoryName}}`} />
  //            </Avatar>
  //          </div>
  //          <div className="listOMCatR">
  //            <span style={{ fontSize: 22, color: "black", fontWeight: "bold" }} >{categoryName}</span>
  //            <br style={{ lineHeight: '0px', }} />
  //            <p style={{ fontSize: 18, color: "black", fontWeight: "normal", wordWrap: "true", lineHeight: "100%" }} >{categoryDesc}</p>
  //          </div>
  //        </div> : null}
  //      <div className="listOrderRow" onClick={(e) => this.addItemToOrder(item)}>
  //        <div className="listCol1">
  //          <span style={{ fontSize: 16, color: "black", fontWeight: "bold" }} >{item.ItemName}&nbsp;&nbsp;&nbsp;
  //            {item.IsFavorite ?
  //              <Favorite alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />
  //              :
  //              <FavoriteSelect alt="" fill={SessionInfo.addColor} id="FavoriteSelectBtn" title={`Set ${item.ItemName} as Favorite`} className="favoriteImage" onClick={(e) => this.addItemToFavorites(item)} />}
  //          </span><br />
  //          <span style={{ fontSize: 13, color: "black" }}>{item.ItemDescription}</span>
  //        </div>
  //        <div className="listColR">
  //          <div className="listCol2">
  //            <span style={{ fontSize: 18, color: "black", fontWeight: "bold" }} >{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px', }} />
  //            {item.IsSelected ?
  //              <span style={{ fontSize: 16, color: "#3e80ed", fontWeight: "bold" }} >{moneyFormat(item.ItemTotal)}</span> :
  //              <div>
  //                <span> &nbsp; &nbsp; &nbsp; </span>
  //                {item.IsQuick ?
  //                  <CirclePlus alt="" fill={SessionInfo.quickColor} id="AddItemBtn" title={`Quick Add Item ${item.ItemName} to the Order`} className="functionImage" onClick={(e) => this.quickAddItemToOrder(item)} /> : null}
  //              </div>
  //            }
  //            <div className="iconLine">
  //              {item.IsSelected ?
  //                <CartEdit alt="" fill={SessionInfo.removeColor} id="ChooseItemBtn" title={`Choose what to do with Item ${item.ItemName}`} className="functionImage" onClick={(e) => this.choiceForItem(item)} />
  //                :
  //                <CartAdd alt="" fill={SessionInfo.addColor} id="AddItemBtn" title={`Add Item ${item.ItemName} to the Order`} className="functionImage" onClick={(e) => this.addItemToOrder(item)} />}
  //              {item.IsPromotion ?
  //                <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="functionImageR" onClick={(e) => this.addShowPromotion(item)} /> : null}
  //            </div>
  //          </div>
  //          <div className="listOMImageDiv1">
  //            <Avatar rounded='large' size='large' type='image' style={{ height: '76px', width: '76px', }}>
  //              <img src={item.imageVal} alt='' style={{ height: '76px', width: '76px', }} title={`${item.ItemName} (Photo Coming}`} onClick={(e) => this.addItemToOrder(item)} />
  //            </Avatar>
  //          </div>
  //        </div>
  //      </div>
  //    </div>
  //  );
  //}   
  OrderItemFooter = () => {
    return (
      <ListViewFooter className='listOrderFooter'>
      </ListViewFooter>
    );
  }
  OrderFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listOrderFooter'>
        <div className='listFooterLeft'>
          <span className='listName'>SubTotal </span>
          <span className='listMoney'>{moneyFormat(this.state.SubTotalPrice)}</span>
          <br />
          <span className='listName'>Tax </span>
          <span className='listMoney'>{moneyFormat(this.state.TotalTaxAmount)}</span>
          <br />
          <span className='listName'>TOTAL </span>
          <span className='listMoney'>{moneyFormat(this.state.TotalPrice)}</span>
        </div>
        <div className='listFooterRight'>
          <Button id="checkoutButton2" icon="cart" look="outline" className="largeButton" onClick={this.onCheckout} >&nbsp;Place Order &nbsp;</Button>
        </div>
      </ListViewFooter>
    );
  }
  //OrderFooter = () => {
  //  return (
  //    <ListViewFooter className='listFooter'>
  //      <div className='footerLeft'>
  //        <span>SubTotal </span>
  //        <span>{moneyFormat(this.state.SubTotalPrice)}</span>
  //        <br />
  //        <span style={{ left: '180px', }}>Tax </span>
  //        <span>{moneyFormat(this.state.TotalTaxAmount)}</span>
  //      </div>
  //      <div className='footerRight'>
  //        <span>TOTAL </span>
  //        <span>{moneyFormat(this.state.TotalPrice)}</span>
  //        <br />
  //        <Button id="checkoutButton" icon="restore" style={{ cursor: 'pointer', fontSize: 'large', color: 'black', fontWeight: 'bold', borderRadius: '10px', left: '80px', }} onClick={this.onCheckout} >&nbsp;&nbsp; Checkout &nbsp;&nbsp;</Button>
  //      </div>
  //    </ListViewFooter>
  //  );
  //}

  gotoLanding = async () => {
    trace("Go To LandingPage");
    this.props.navigate("/LandingPage");
  }
  onDeleteItem = async (item) => {
    if (item.ItemStatusID > 0) {
      displayMessage(`Item: ${JSON.stringify(item.ItemName)} Deleted`);
    }
    trace(`Delete ID: ${JSON.stringify(item.CustomOrderItemID)}`);
    this.setState({
      OrderItems: this.state.OrderItems.filter(e => e.CustomOrderItemID !== item.CustomOrderItemID)
    });
    await this.deleteOrderStoreItem(item.CustomOrderItemID);
    this.getCurrentTotal();
  }
  onDeleteSLItem = async item => {
    //displayMessage(`SL Item: ${JSON.stringify(props.ItemName)} Deleted`);
    trace(`SL Item: ${JSON.stringify(item)} to be Deleted`);
    trace(`Delete ID: ${JSON.stringify(item.ShoppingListItemID)}`);
    this.setState({
      ShoppingListItems: this.state.ShoppingListItems.filter(e => e.ShoppingListItemID !== item.ShoppingListItemID)
    });
    await this.deleteShoppingListItem(item.ShoppingListItemID);
    this.getCurrentTotal();
  }
  onDeleteShoppingList = async (item) => {
    //evt.stopPropagation();
    trace(`Delete ID: ${JSON.stringify(item.ShoppingListID)}`);
    this.setState({
      ShoppingLists: this.state.ShoppingLists.filter(e => e.ShoppingListID !== item.ShoppingListID)
    });
    await this.deleteShoppingList(item.ShoppingListID);
  }
  //--------------------App Functions --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  getOrderItemRecords = async (search) => { // Get the order Items according to the search
    if (!search)
      search = '';
    trace(`===> getOrderItemRecs - CustomOrderID: ${SessionInfo.CustomOrderID}, CustomOrderType: ${SessionInfo.OrderType}`)
    if (SessionInfo.CustomOrderID > 0) {
      let CD = await CallOM("GetCustomOrderItems",0,SessionInfo.CustomOrderID,0,search,'',68); // Get OrderItems with the NO image (MOID=5) - MOID=1-tiny, MOID=9-Medium - + 2 -> Full Description + 0x40 (64) sort backward
      this.setState({ ItemSelect: "" });
      //trace(`Get Current Order Items: ${JSON.stringify(CD.d)}`);
      if (CD.x.o === 0)
        await LogOffResetMsg(`getOrderItemRecords Has Failed - search: ${search} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        try {
          this.setState({ ItemSelect: search });
          const OrderItems = CD.d.rows.map(dataItem => Object.assign({ selected: false },dataItem));
          this.setState({ OrderItems });
          this.saveOrderItems = OrderItems.slice();
        } catch (error) {
          await OMTrace(2,`Failure in getOrderItemRecords - Error: ${error}`);
        }
      } else {
        displayWarning(CD.x.m);
      }
    }
  }
  getAddOrderItemRecord = async (barcode) => {
    if (SessionInfo.CustomOrderID === 0) {
      trace(`Add CustomerOrderID`);
      await this.addOrder(''); // Add a CustomOrder if required
    }
    trace(`CallGetAddStoreItem - Barcode: ${barcode}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
    let Parm2 = 0;
    if (SessionInfo.AC.ScanItemImages == false)
      Parm2 = 0x05;
    if (SessionInfo.CustomOrderID > 0) {
      let CD;
      if (this.scanWeight === true) { // The current scan is the weight for the item  
        trace(`Scan Weight`);
        Parm2 = 100; // Add Weight - don't return Image
      } else {
        Parm2 = 5;
      }
      trace(`getAddOrderItemRecord - CustomOrderItemID: ${this.CustomOrderItemID}, Parm2: ${Parm2}`);
      CD = await CallOM("GetAddStoreItem",SessionInfo.CustomOrderID,this.CustomOrderItemID,CTYP.STR,barcode,'',Parm2);
      this.setState({ ItemSelect: "" });
      //trace(`New Order Item: ${JSON.stringify(CD)}`);
      if (CD.x.o === 0)
        await LogOffResetMsg(`getAddOrderItemRecord Has Failed - Key: ${barcode} - Ses/sion: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        try {
          //trace(`Add OrderItem: ${JSON.stringify(CD.d)}`);
          let NewOrderItem = CD.d;
          this.CustomOrderItemID = NewOrderItem.CustomOrderItemID;
          trace(`CustomOrderItemID: ${this.CustomOrderItemID}`);
          if (NewOrderItem.RateTypeID > 1 && this.scanWeight === false) { // Show the Barcode scanner to scan the Weight
            this.scanWeight = true;
            this.scanBorder = this.scanWeightB;
            this.saveImage = NewOrderItem.Image;
            this.setState({ barcodeMessage: ">> Scan the Scale Weight <<" });
            this.startScan();
          } else { // Either standard item - or this is the weight
            let inform = " Added";
            if (this.scanWeight === true) { // The current scan is the weight for the item 
              inform = this.state.Quantity + " " + inform;
              NewOrderItem.Image = this.saveImage;
              this.scanWeight = false;
            } else if (this.state.Quantity > 1) {
              inform = this.state.Quantity + " " + inform;
            }
            // Add the OrderItem - look for existing Pending Item
            this.setState({ orderMessage: this.state.ItemName + inform });
            let OrderItems = this.state.OrderItems.slice();
            let ix = OrderItems.findIndex(storItem => storItem.CustomOrderItemID === this.CustomOrderItemID);
            if (ix >= 0) { // See if the existing one has Pending Status - Remove the existing item and then add the new one at the beginning
              if (NewOrderItem.foundPending === true) {
                console.log(`splice - ix: ${ix}`);
                OrderItems.splice(ix,1); // Delete the pending one
              }
            }
            OrderItems.unshift(NewOrderItem); // Add New Item at the Start of the list
            this.setState({ OrderItems });
          }
        } catch (error) {
          await OMTrace(2,`Failure in getAddOrderItemRecord in Scanner - Error: ${error}`);
        }
      }
    }
  }
  deleteShoppingListItem = async (ShoppingListItemID) => {
    trace(`ShoppingListItem - ID: ${ShoppingListItemID}`);
    await CallOM("DeleteShoppingListItem",0,ShoppingListItemID,0,'','',99);
  }
  deleteShoppingList = async (ShoppingListID) => {
    trace(`ShoppingList - ID: ${ShoppingListID}`);
    await CallOM("DeleteShoppingList",0,ShoppingListID,0,'','',99);
  }
  deleteOrderStoreItem = async (customOrderItemID) => {
    trace(`DeleteOrderItem - ID: ${customOrderItemID}`);
    await CallOM("DeleteOrderItem",0,customOrderItemID,0,'','',99);
    await this.getOrderItemRecords();
    await this.getCurrentTotal();
  }
  addOrder = async (seatName) => {
    let CD;
    try {
      if (SessionInfo.CustomOrderID === 0) { // Add a CustomOrder
        trace(`Create CustomOrder (1) - StoreLocationID: ${SessionInfo.StoreLocationID}, seatName: ${seatName}`);
        SessionInfo.CurrentTableID = 0;
        let orderType = 3; // Scanner Order
        let individualItems = true;
        // int: 1 // string:2  decimal:3  double: 4  datetime:5  bool:6  unknown:9
        CD = await CallOM("CreateCustomOrderTab",0,SessionInfo.StoreLocationID,CTYP.TypParm,[TYP.INT,orderType,TYP.INT,this.state.AddressID,TYP.STR,"",TYP.STR,seatName,TYP.INT,SessionInfo.CurrentTableID]); //,TYP.BOOL,individualItems]);
        if (CD.x.o === 0)
          await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
        else if (CD.x.o < 9500) {
          trace("addOrder data: " + JSON.stringify(CD.d));
          SessionInfo.CustomOrderID = CD.d.CustomOrderID;
          this.setState({ TableName: CD.d.TableName });
          this.setState({ SeatCount: CD.d.SeatCount });
          SessionInfo.CurrentTableName = CD.d.TableName;
          SessionInfo.SeatCount = CD.d.SeatCount;
          if (SessionInfo.SeatName === '')
            SessionInfo.SeatName = `Seat #: ${SessionInfo.SeatCount}`;
          SessionInfo.ParentOrderID = CD.d.ParentOrderID;
          trace(`CreateCustomOrderTabID: ${SessionInfo.CustomOrderID}, TableName: ${this.state.TableName}`);
        }
      }
    } catch (error) {
      await OMTrace(2,`Failure in addOrder in ScannerPage - Error: ${error}`);
    }
    return
  }
  addOrderItem = async (barcode) => {
    let CD;
    try {
      trace(`addItem - OrderID: ${SessionInfo.CustomOrderID}`);
      if (SessionInfo.CustomOrderID === 0) { // Add a CustomOrder 
        await this.addOrder('');
      }
      CD = await CallOM("AddOrderItem",0,SessionInfo.CustomOrderID,CTYP.STR,barcode); // Process Promotion Information and any other related processing   
      if (CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        trace("addOrderItem data: " + JSON.stringify(CD.d));
        this.setState({ orderMessage: `${CD.d.StoreItemID} Added` });
        await this.getOrderItemRecords('');
        await this.getCurrentTotal();
        //JArray Rw = (JArray)CD.d;
        //CurrentCOI = new CustomOrderItem(new StoreItem(Rw));
        //CurrentCOI.RateTypeID = (int)Rw[6];
        //CurrentCOI.CustomOrderItemID = (int)Rw[8]; // Returned from GetStoreItem
        //CurrentCOI.RateDescription = CurrentCOI.ShortDescription = (string)Rw[9];
        //App.CurrentCOI = CurrentCOI;
        //bool isNew = true;
        //if (isNew === true) {
        //  CustomOrderItems.Insert(0, CurrentCOI);
        //  CD.x.o = 8000;
        //}
        //App.CartCount = CustomOrderItems.Count;
        //ScanItems = $"SCAN ITEMS ({App.CartCount})";
      }
      else {
        this.startScan(); // Retry the scan
      }
    } catch (error) {
      await OMTrace(2,`Failure in addOrderItem in ScannerPage - Error: ${error}`);
    }
    return CD;
  }
  getCurrentTotal = async () => {
    trace(`CallgetCurrentTotal - CustomOrderID: ${SessionInfo.CustomOrderID}`);
    if (SessionInfo.CustomOrderID > 0) {
      let CD = await CallOM("GetCustomOrderTotal",0,SessionInfo.CustomOrderID,0);
      if (CD.x.o === 0)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else if (CD.x.o < 9500) {
        try {
          let Row = CD.d;
          let SubTotalPrice = Row["TotalPrice"];
          this.setState({ SubTotalPrice });
          let TotalTaxAmount = Row["TotalTaxAmount"];
          this.setState({ TotalTaxAmount });
          let TotalPrice = SubTotalPrice + TotalTaxAmount;
          this.setState({ TotalPrice });
          let ItemCount = Row["ItemCount"];
          let SLItemCount = Row["SLItemCount"];
          this.setState({ ItemCount });
          this.setState({ NetItemCount: ItemCount - SLItemCount });
          this.NetItemCount = ItemCount - SLItemCount;
          trace(`ItemCount: ${SessionInfo.ItemCount}, SLItemCount: ${SLItemCount}, ItemCount: ${ItemCount}, Net: ${this.NetItemCount} `);
        } catch (error) {
          await OMTrace(2,`Failure in getCurrentTotal - Error: ${error}`);
        }
      }
    }
  }
  onCheckout = () => {
    if (this.state.TotalPrice > 0) {
      trace(`Goto CheckoutPage - CustomOrderID: ${SessionInfo.CustomOrderID}`);
      this.props.navigate("/CheckoutPage");
    }
    else {
      displayError(`No Items Added For Checkout (${moneyFormat(this.state.TotalPrice)})`);
    }
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Show Item Detail - Note - this is all copied from OrderPage
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  choiceForItem = async (event,item,rowIdx) => {
    event.stopPropagation();
    //trace(`choose For Item: ${JSON.stringify(item)}`);
    this.cancelAddClick = true;
    let storeItemID = item.StoreItemID;
    let itemName = item.ItemName
    this.editSLItem = true;
    this.setState({ chooseItemName: itemName });
    trace(`chooseStore Item: ${JSON.stringify(itemName)}, editSLItem: ${this.editSLItem}`);
    //trace(`choose - selectedItems: ${JSON.stringify(this.state.OrderItems)}`);
    let ix = this.state.OrderItems.findIndex(selItem => selItem.ItemID === storeItemID);
    if (ix < 0)
      trace(`selectedItems do not contain storeItemID: ${storeItemID}`);
    else
      this.CustomOrderItemID = this.state.OrderItems[ix].CustomOrderItemID;
    //trace(`storeItemID: ${storeItemID}, ix: ${rx}, rowIdx: ${rowIdx}, OrderItemID: ${this.CustomOrderItemID}`);
    if (rowIdx > 0)
      this.itemChangeOffset.top = rowIdx * this.listRowHeight + this.listTopHeight;
    else
      this.itemChangeOffset.top = this.listTopHeight;
    this.changeRowIdx = rowIdx;
    // Check for multiple orderItems for same storeItem
    let CD = await CallOM("GetOrderItemsForItem",SessionInfo.CustomOrderID,storeItemID,0);
    if (CD.x.o === 0 || CD.x.o > 9500) {
      //await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      this.props.navigate("/Login");
    } else {
      let ItemsList = CD.d.rows; // List of OrderItems                                 
      trace(`OrderItem info: ${JSON.stringify(CD.d)}, ItemListLth: ${ItemsList.length}`);
      if (ItemsList.length > 0) { // At least one item has been selected
        this.CustomOrderItemID = ItemsList[0].CustomOrderItemID;
        //let item = ItemsList[0]; // The first set
        //trace(`Multi info for: ${itemName}, storeItemID: ${storeItemID}, OrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID} ItemList Lth: ${ItemsList.length}`);
        trace(`Multi Items: ${JSON.stringify(ItemsList)}`);
        //this.setState({ showInfoChange: false });
        await this.setState({ ItemsList }); // Items List in Order for the Item
        // 27Aug24 - This is the number of items selected with options - the options may be different
        if (ItemsList.length > 1) { // Multiple Items have been selected
          this.setState({ OptionStatus: "" });
          this.setState({ showChangeItems: true }); // Show orderitem selection
        }
        else
          this.setState({ showChangeItems: false });
        trace(`====> change Item: ${item.StoreItemID}, Order: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID},${item.CustomOrderItemID}, showChangeItems: ${this.state.showChangeItems}, changeRowIdx: ${this.changeRowIdx} `);
        if (item.CustomOrderItemID && item.CustomOrderItemID > 0)
          this.CustomOrderItemID = item.CustomOrderItemID;
        SessionInfo.CurrentItem = item;
        SessionInfo.PromoStoreItemID = 0;
        SessionInfo.SelectedItems = this.state.selectedItems;
        this.topLevelStoreItem = this.StoreItemID;
        this.cancelAddClick = false;
        await this.displayAddItemToOrder(item,rowIdx,true); // Change
      }
      else
        this.setState({ showChangeItems: false });
    }
  }
  displayAddItemToOrder = async (item,rowIdx,isChange) => {
    // NOTE: current Order Information is in this.state.ItemsList
    //trace(`==> displayAddItemToOrder: ${JSON.stringify(item)}, rowIdx: ${rowIdx}`);
    //await this.displayAddFullItemToOrder(item,rowIdx,isChange,false);
    if (SessionInfo.AC.HasDetail === true) { // This is set to false if ApplicationTypeID < 2
      trace(`---> Display - ID: ${item.StoreItemID}, rowIdx: ${rowIdx}, inAddOrderItem: ${this.inAddOrderItem}, CustomOrderItemID: ${this.CustomOrderItemID}, isChange: ${isChange}, Options: ${item.HasOptions}`);
      if (this.inAddOrderItem === false) { // Control double click
        try {
          this.inAddOrderItem = true; // Prevent multiple calls to this function
          trace(`Add/Change Item: ${item.StoreItemID}, Order: ${SessionInfo.CustomOrderID}, OrderItemID: ${this.CustomOrderItemID}, ItemDetailSecondLevel: ${ItemDetailSecondLevel}, displayItemDetail: ${this.state.displayItemDetail}, cancelAddClick: ${this.cancelAddClick}, menu select: ${SessionInfo.MenuLayoutSelection}, detailHeaderHeight: ${this.detailHeaderHeight}`);
          // Note - This will close the current window if open - user will have to hit item again to open
          if (ItemDetailSecondLevel === false && this.state.displayItemDetail === true)
            this.setState({ displayItemDetail: false }); // Note sure? Does this mean already in DisplayItem
          else if (this.cancelAddClick === false) {
            SessionInfo.CurrentItem = item;
            this.StoreItemID = item.StoreItemID;
            SessionInfo.PromoStoreItemID = 0;
            //this.CustomOrderItemID = 0;
            SessionInfo.SelectedItems = this.state.selectedItems;
            //if (SessionInfo.MenuLayoutSelection === 3)
            //  SessionInfo.CurrentImage = item.imageVal;
            trace(`====> HasOptions: ${item.HasOptions}, count: ${item.OptionCount}, related: ${item.HasRelated}  showChangeItems: ${this.state.showChangeItems},detailHeaderHeight: ${this.detailHeaderHeight}`);
            //if (item.HasOptions === true || item.HasRelated === true) { // Options or Related Information indicated in Item Retrieval - show FULL Detail 
            //  await this.displayAddFullItemToOrder(item,isChange,true); // Display options/related
            //} else { // Display Item Description & Price with or without Image    
            //if (SessionInfo.MenuLayoutSelection === 3) // No Images - not sure if this is relevant 
            //  this.setState({ ProductItemPhotoURL: SessionInfo.CurrentImage });
            await this.displayAddFullItemToOrder(item,isChange,false);
            //}
          }
        } catch (ex) {
          trace(`displayAddItemToOrder - error: ${ex}`);
          this.inAddOrderItem = false;
        } finally {
          this.inAddOrderItem = false;
        }
      }
    }
    this.cancelAddClick = false;
  }
  //---------------------------------------- OrderItems Initialize - Component Did Mount ---------------------------------------- 
  displayAddFullItemToOrder = async (item,isChange,loadFull) => {
    try {
      this.setState({ showPromo: false });
      this.setNotifyMessage(false);
      trace(`displayAddFullItemToOrder - image: ${item.imageVal}, OptionCount: ${this.OptionCount}, loadFull: ${loadFull}, offset: ${this.OffsetToUse}`);
      this.setState({ ProductItemPhotoURL: item.imageVal });
      //this.setState({ image: SessionInfo.CurrentImage });
      //trace(`item: ${JSON.stringify(item)}`);
      //this.resetOptions();
      this.compUpdate = false; // Stop Updates
      this.OptionCount = 0;
      this.OptionElementCount = 0;
      this.RelatedItemCount = 0;
      this.setState({ OptionStatus: "" });
      // Load Store Item - and Option Groups and Options
      this.StoreItemID = item.StoreItemID;
      const startTime = performance.now();
      document.documentElement.style.setProperty('--options-image-height',`${this.imageHeight}px`); // Set to standard Image Height   
      document.documentElement.style.setProperty('--itemDetailPopupHt',`${560}px`); // Reset Popup Height 
      await this.loadStoreItem(item,loadFull,true); // Load the Item and the Options - this.StoreItemID 
      if (SIV.HasOptions === true)
        loadFull = true;
      this.LoadFull = loadFull;
      // Set Height of Description ---- Make adjustment for Long Description in Header - Set size of popup? ----- 
      let baseHeight = 480;
      if (this.LoadFull === true)
        baseHeight = 650;
      else
        this.AllOptionsDone = true;
      this.descAdjust = 24;
      let IDLth = SessionInfo.SIV.ItemDescription.length;
      //trace(`Item Desc: ${SessionInfo.SIV.ItemDescription}`);
      trace(`Item Desc Lth: ${IDLth}`);
      if (IDLth > 50) { // Note - this seems to work fine for 16px font size
        this.descAdjust += Math.floor((IDLth / 48) * 17); // Adjustment for Number of Description Lines - Assume 48/Line - 15px per line - see line-height in optionHeader
        trace(`Description adjust: ${this.descAdjust}`);
      }
      this.setState({ DescHeight: this.descAdjust }); // Standard height is 24 + adjustment for long descriptions
      // This is always first level
      // Note that Options are loaded above in loadStoreItem
      let specInstAdjust = 0;
      this.topLevelStoreItem = this.StoreItemID; // Note - the only place that this is set
      if (isChange === true) { // Load current OrderItem information for existing OrderItem
        trace(`---> ChangeItem in Display: ${item.StoreItemID}, isChange: ${isChange}`);
        this.setState({ isItemChange: true });
        await this.loadOrderItem(item,isChange); // SessionInfo.CurrentItem
        specInstAdjust = 0;
        //  this.setState({ RelatedItems: [] });
        //  this.RelatedItemCount = 0; // Related should not show on Change
      }
      else { // New Item
        this.setState({ isItemChange: false });
        this.setState({ TotalPrice: this.state.ItemPrice });
        this.setState({ SpecialInstruction: '' });
        if (this.LoadFull === true && ItemDetailSecondLevel === false) {
          await this.loadRelatedItems(''); // Note - related items not added for second level popup
        }
        else {
          await this.setState({ RelatedItems: [] });
        }
      }
      const endTime = performance.now();
      const executionTime = Math.round(endTime - startTime);
      console.log(`===> loadStoreItem execution time: ${executionTime} milliseconds`);
      trace(`---> after loadStoreItem - change: ${isChange}, current: ${this.StoreItemID}, promo: ${SessionInfo.PromoStoreItemID}, hasOption: ${SIV.HasOptions}, Option Count: ${this.OptionCount}, related: ${this.RelatedItemCount}, loadFull: ${this.LoadFull}`);
      this.hideItemImage = false;
      this.setState({ hideOptionImage: false });
      this.detailHeaderHeight = this.imageHeight + 155; // 230 + Standard 
      if (SIV.HasOptions === true) {
        this.detailHeaderHeight += 24;
      }
      if (this.showInfo === true)
        specInstAdjust = 54; // Special Instructions
      this.detailHeaderHeight += this.descAdjust + specInstAdjust; // long description and specialinstructions adjustment to header element 
      this.listHeight = this.OptionCount * 30 + this.OptionElementCount * 15 + this.RelatedItemCount * 45; // Height of the option and related lists
      this.popupHeight = baseHeight + this.descAdjust + specInstAdjust + this.listHeight;
      this.scrollPopup = false; // see scrollOptions
      trace(`DISPLAY headerHT: ${this.detailHeaderHeight}, baseHT: ${baseHeight}, descAdjust: ${this.descAdjust}, imageHT: ${this.imageHeight}, showInfoHT: ${specInstAdjust}, listHT: ${this.listHeight}, popupHT: ${this.popupHeight}, window height: ${SessionInfo.height}`);
      SessionInfo.height = window.innerHeight;
      if (this.popupHeight > (SessionInfo.height - 60)) {
        this.popupHeight = SessionInfo.height - 60;
        this.scrollPopup = true;
      }
      trace(`        OptionGroups: ${this.OptionCount}, OptionCount: ${this.OptionElementCount}, Related: ${this.RelatedItemCount}, listHeight: ${this.listHeight}, scrollPopup: ${this.scrollPopup}`);
      this.setDisplayHeights();
      this.setState({ itemChanged: false });
      this.setState({ displayItemDetail: true });
    }
    catch (error) {
      trace(`displayAddFullItemToOrder Init Err: ${error}`,5);
    }
    this.compUpdate = true; // Updates back on
  }
  scrollOptions = (event) => { // scroll the options when too tall to fit in popup
    // console.log(event.currentTarget.scrollTop); - scroll position
    //trace(`Scroll Options - hideImage: ${this.hideItemImage}, stopScroll: ${this.stopScroll}`);
    if (this.hideItemImage === false && this.stopScroll === false) {
      //if (this.scrollPopup === true)
      this.hideImage();
    } // Note 27Sep24 - there is a problem if the options almost fit - so you scroll and it removes the image - which puts the scrollTop back to 0 which shows the image and then it doesn't fit
    this.stopScroll = false;
    //  else if (event.currentTarget.scrollTop === 0) {
    //    this.showImage();
    //  }
  }
  setDisplayHeights = () => {
    trace(`DisplayHeights: detailHeaderHeight: ${this.detailHeaderHeight}, popupHeight: ${this.popupHeight}, listHeight: ${this.listHeight}, scrollPopup: ${this.scrollPopup}`);
    document.documentElement.style.setProperty('--options-header-height',`${this.detailHeaderHeight}px`); // Image + Description Height 
    document.documentElement.style.setProperty('--itemDetailPopupHt',`${this.popupHeight}px`); // Popup Height 
    document.documentElement.style.setProperty('--options-list-height',`${this.listHeight}px`); // option list Height 
  }
  loadStoreItem = async (currentItem,loadFull,getImage) => { // Load Detail Information including Options
    try {
      let ImageID = 0;
      let currentImageID = 0;
      trace(`loadStoreItem - current: ${this.StoreItemID}, promo item: ${SessionInfo.PromoStoreItemID}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
      //trace(`*** currentItem: ${JSON.stringify(currentItem)}`);
      if (SessionInfo.PromoStoreItemID > 0) // ** NOTE **
        this.StoreItemID = SessionInfo.PromoStoreItemID;
      this.setState({ StoreLocationItemID: this.StoreItemID });
      //let CD = await CallOM("GetFullDescription",SessionInfo.CustomOrderID,this.StoreItemID,0);
      //trace("after Get GetFullDescription: " + JSON.stringify(CD.d));
      currentItem.FullDescription = "Not Fetched";
      //var row = CD.d;
      //let CD = await CallOM("GetStoreItem",SessionInfo.CustomOrderID,this.StoreItemID,0);
      //trace("after Get StoreItem: " + JSON.stringify(CD.d));
      //var row = CD.d;
      var row = currentItem; // Note - use currentItem to populate fields - Note - still need full description
      if (row) {
        StoreItemsO.forEach(elem => {
          if (elem.n in row) {
            //trace(`Set ${elem.n}: ${row[elem.n]}`);
            let sobj = {};
            try {
              if (elem.t === 34 || elem.t === 35) { // Date, DateTime
                sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
                //sobj[elem.n] = row[elem.n];
                SIV[elem.n] = new Date(row[elem.n]);
              } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
                sobj[elem.n] = row[elem.n];
                //let sobjS = {};
                //sobjS[elem.n + 'S'] = row[elem.n];
                ////trace(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
                //this.setState(sobjS); // Set the String shadow var
                SIV[elem.n] = row[elem.n];
              } else if (elem.t === 28) { // Money
                sobj[elem.n] = row[elem.n];
                //let sobjS = {};
                //sobjS[elem.n + 'S'] = moneyFormat(row[elem.n]);
                ////trace(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
                //this.setState(sobjS); // Set the String shadow var
                SIV[elem.n] = row[elem.n];
              } else if (elem.t === 41) { // Media - Image or Document
                sobj[elem.n] = row[elem.n];
                SIV[elem.n] = row[elem.n];
                if (elem.n === 'ImageID')
                  currentImageID = row[elem.n];
                //} else if (elem.t === 15) { // Encoded
                //  trace(`Encoded sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${SIV[elem.n]}`);
              } else {
                sobj[elem.n] = row[elem.n];
                SIV[elem.n] = row[elem.n];
              }
              //trace(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${SIV[elem.n]}`);
              //if (this.state[elem.n] === undefined)
              //  trace(`=== ${elem.n} is not defined in state ===`);
              this.setState(sobj);
            }
            catch (error) {
              trace(`Set StoreItemsO Field: ${elem.n}, Error: ${error.message}`,5);
            }
          }
        });
        //trace(`SIV: ${JSON.stringify(SIV)}`);
        this.setState({ SpecialInstruction: "" });
        //let index = StoreItemsO.findIndex(p => p.n === "ImageID"); // Note - for new line will find 0
        trace(`Fetch StoreItemID: ${this.StoreItemID}, New StoreItemID: ${SIV.StoreItemID}, ImageID: ${SIV.ImageID},${currentImageID}, imageVal: ${SIV.imageVal}, HasOptions: ${SIV.HasOptions}`);
        SessionInfo.SIV = SIV;
      }
      this.setState({ TotalPrice: SIV.ItemPrice });
      this.setState({ OptionsPrice: 0 });
      SessionInfo.headerTitle = SIV.ItemName;
      trace(`ProductItemPhotoURL-2 URL: ${currentItem.imageVal}, SIV.ImageID: ${SIV.ImageID}`);
      if (getImage == true && !currentItem.imageVal) {
        await this.GetProductItemImage(SIV.ImageID); // This takes 15% of the load time 
        //this.setState({ ProductItemPhotoURL: currentItem.imageVal });
      }
      else
        this.setState({ ProductItemPhotoURL: currentItem.imageVal });
      //-----------------------------------------------------------------
      if (loadFull === true) {
        this.setState({ displayItemDetail: true });
        this.forceUpdate(); // 3Oct24 - this works - display initial (short) popup
      }
      //-----------------------------------------------------------------
      this.setState({ stateHasChanged: false });
      if (SIV.HasOptions === true)
        loadFull = true;
      if (loadFull === true) { // This takes 70% of the time 
        //this.setState({ displayItemDetail: true }); 
        //this.forceUpdate(); // 3Oct24 - this works
        await this.LoadGroupData(this.StoreItemID);
        trace("---------- Load Options Complete ----------");
      }
      else
        this.AllOptionsDone = true;
    }
    catch (Ex) {
      trace(`Error in LoadStoreItem: ${Ex}`);
    }
  }
  loadOrderItem = async (currentItem,isChange) => {
    try {
      trace(`*** loadOrderItem - CustomOrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID}`);
      if (currentItem) {
        //trace(`*** currentItem: ${JSON.stringify(currentItem)} - StoreItemID: ${currentItem.StoreItemID}`);
        this.StoreItemID = currentItem.StoreItemID;
        trace(`Location: ${this.state.StoreLocationID}, Item: ${this.StoreItemID}`);
        let CD = await CallOM("GetOrderItemForItem",SessionInfo.CustomOrderID,this.StoreItemID,0,undefined,undefined,this.CustomOrderItemID); // CustomOrderItemID = _OMO.ActiveParm2
        trace("after GetOrderItemForItem: " + JSON.stringify(CD.d));
        var row = CD.d;
        if (row) {
          CustomOrderItemsO.forEach((elem) => {
            if (elem.n in row) {
              //trace(`Set ${elem.n}: ${row[elem.n]}`);
              let sobj = {};
              try {
                if (elem.t === 34 || elem.t === 35) // Date, DateTime
                  sobj[elem.n] = new Date(row[elem.n]);
                else if (elem.t === 28) {
                  sobj[elem.n] = row[elem.n];
                  let sobjS = {};
                  sobjS[elem.n + 'S'] = moneyFormat(row[elem.n]);
                  //trace(`Set Money Field: ${elem.n + 'S'} Value: ${sobjS[elem.n + 'S']}`);
                  this.setState(sobjS);
                }
                else
                  sobj[elem.n] = row[elem.n];
                //trace(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${COIV[elem.n]}`);
                this.setState(sobj);
                COIV[elem.n] = row[elem.n];
                // Add item specific code here
                //if (elem.n === "ImageID")
                //  ImageID = row[elem.n];
              } catch (error) {
                trace(`Set StoreItemsO Field: ${elem.n} Error: ${error.message}`);
              }
            }
          });
        }
        let ImageID = 0;
        if ("ImageID" in row)
          ImageID = row.ImageID;
        trace(`after get item - imageID: ${ImageID}`);
        //if (getImage == true && !currentItem.imageVal) {
        await this.GetProductItemImage(ImageID); // This takes 15% of the load time 
        //this.setState({ ProductItemPhotoURL: currentItem.imageVal });
        //}
        this.ExistQty = this.state.Quantity;
        let CustomOrderItemID = row["ID"];
        //  if (this.state.showChangeItems === false) {
        //    trace(`*** loadItem Options - StoreItemID: ${currentItem.StoreItemID}, CustomOrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID}`);
        //    CD = await CallOM("GetOrderItemOptionsList",0,CustomOrderItemID,0);
        //    trace(`Options: ${JSON.stringify(CD.d)}, OptionsPrice: ${this.state.OptionsPrice}, ${COIV.OptionsPrice}`);
        //    let rows = CD.d.rows;
        //    for (let rx = 0; rx < rows.length; rx++) {
        //      //trace(`Options  GrpID: ${rows[rx].GrpName}, OptID: ${rows[rx].POName}`);
        //      for (let ix = 0; ix < this.state.Options.length; ix++) {
        //        //trace(`Options Lth: ${this.state.Options[ix].length}, Key: ${this.optionKeys[ix]}, multi: ${this.state.optionMultiCnt[ix]}`);
        //        if (this.optionKeys[ix] === rows[rx].GrpName) {
        //          for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
        //            //trace(`option - ix:${ix}, ox:${ox}, key:${this.optionKeys[ix]} option: ${JSON.stringify(this.state.Options[ix][ox])}`);
        //            if (this.state.Options[ix][ox].ID === rows[rx].POName) {
        //              //this.state.Options[ix][ox].Select = true;
        //              this.OnOptionItemSelected(ix,this.state.Options[ix][ox],isChange);
        //              this.setState({ Options: this.state.Options.slice() });
        //              //this.setState({ optionStates: this.state.optionStates.slice() });
        //              break;
        //            }
        //          }
        //        }
        //      }
        //    }
        //  }
      }
    }
    catch (Ex) {
      trace(`Error in loadOrderItem: ${Ex}`);
    }
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // End of Code copied from OrderPage
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Select Tabs
  //searchCurrent = async (search) => {
  //  if (this.state.selectedTopTab === 2) {
  //    displayMessage("Search Receipts");
  //    this.setState({ customOrdersSkip: 0 });
  //    this.setState({ customOrdersTake: 8 })
  //    this.setState({ receiptFilter: { logic: "and", filters: [] } });
  //    this.setState({ receiptSort: [] });
  //    await this.getCustomOrders(search);
  //  }
  //  else {
  //    displayMessage("Search Customers");
  //    await this.getCustomerRecords(search);
  //    this.setState({ customersSkip: 0 });
  //    this.setState({ customersTake: 18 })
  //  }
  //}
  //saveRecord = async () => {
  //  trace("Save Customer");
  //  let copyState = Object.assign({}, this.state);
  //  let type = 0;
  //  for (var prop in copyState) {
  //    //trace("Prop: " + prop + " type: " + type);
  //    if (prop === "string") {
  //      type = 1;
  //      copyState[prop] = undefined;
  //    }
  //    else if (prop === "selectedTopTab")
  //      type = 2;
  //    else if (type === 0) {
  //    }
  //    if (type === 2) {
  //      copyState[prop] = undefined;
  //    }
  //  }
  //  trace("copystate: " + JSON.stringify(copyState));
  //  await UpdateRow(1020151, 0, undefined, copyState, this.state.currentCustomerID, "CustomerID"); // Save to OM
  //  await this.getCustomerRecords();
  //  //await this.getProjectRecords();
  //  this.setState({ stateHasChanged: false });
  //}
  //deleteRecord = async () => {
  //  //trace("Delete ScannerPage: " + this.state.CustomerID);
  //  let CD = await DeleteRow(543619, this.state.currentCustomerID);
  //  trace("Delete Customer - o: " + CD.x.o);
  //  this.setState({ stateHasChanged: false });
  //}
  // Manage Shopping List
  displayNewShoppingList = async (event) => { // Add New List  
    this.setState({ inAddSLList: true });
    await this.displayAShoppingList(event,undefined);
    //await this.displayEditShoppingList(event,undefined);
  }
  displayAShoppingList = async (item) => {
    this.ShoppingListID = 0;
    if (item && item != undefined && item.ShoppingListID > 0) {
      this.ShoppingListID = item.ShoppingListID;
      trace(`display A List: ${JSON.stringify(item)}, ShoppingListID: ${this.ShoppingListID}`);
      this.setState({ ShoppingListName: item.ShoppingListName });
      this.setState({ SLDescription: item.Description });
    }
    let CD = await CallOM("GetShoppingListItems",0,this.ShoppingListID,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`ShoppingList Items CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
      if (CD.d && CD.d.rows) {
        this.setState({ ShoppingListItems: CD.d.rows });
        this.saveShoppingListItems = CD.d.rows;
      }
    }
    this.setState({ displayShoppingList: true });
    this.setState({ displayShoppingLists: false });
  }
  displayList = async (item) => {
    trace(`display List - Item: ${JSON.stringify(item)}`);
  }
  displayAShoppingListItem = async (item) => {
    trace(`display A New Item: ${JSON.stringify(item)}`);
  }
  displayEditShoppingList = async (event,item) => {
    event.stopPropagation();
    this.setState({ inEditSLList: true });
    this.ShoppingListID = item.ShoppingListID;
    trace(`display Edit List: ${JSON.stringify(item)}, ShoppingListID: ${this.ShoppingListID}`);
    this.setState({ ShoppingListName: item.ShoppingListName });
    this.setState({ SLDescription: item.Description });
    let CD = await CallOM("GetShoppingListItems",0,this.ShoppingListID,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`ShoppingList Items CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
      if (CD.d && CD.d.rows) {
        this.setState({ ShoppingListItems: CD.d.rows });
        this.saveShoppingListItems = CD.d.rows;
      }
    }
    this.setState({ displayShoppingList: true });
    this.setState({ displayShoppingLists: false });
  }
  /*-------------------------------------------------------------------------------------*/
  closePopups = (src) => {
    trace(`close Popups - ${src}, keep: ${this.keepMenu}`);
    this.setState({ showNotify: false });
    //if (this.keepMenu === false)
      this.setState({ showMenu: false });
    //else
    //  this.keepMenu = false;
    this.setState({ showBillSummary: false });
  }
  onMenuItemClick = async (event) => {
    trace(`menu event Item: ${event.item.text}`);
    if (SessionInfo.currentItem !== undefined) {
      //trace('Current Item: ' + SessionInfo.currentItem.text);
      SessionInfo.currentItem.selected = false;
    }
    SessionInfo.currentItem = event.item;
    trace('2 Current Item: ' + SessionInfo.currentItem.text);
    event.item.selected = true;
    event.item.expanded = true;
    //trace(`Event - name: ${JSON.stringify(event.item)}`);
    SessionInfo.MenuSelect = event.item;
    this.keepMenu = false;
    this.setState({ showMenu: false });
    if (SessionInfo.menuAction !== undefined) {
      await SessionInfo.menuAction(); // onMenuItemClick in AppMain.js
    }
    this.forceUpdate();
  }
  openMenu = (event) => {
    event.stopPropagation();
    this.closePopups(7);
    //trace(`open Menu - anchor: ${this.menuAnchor.current} - showMenu: ${this.state.showMenu}`);
    this.keepMenu = true;
    this.setState({ showMenu: true });
    trace(`open Menu - showMenu: ${this.state.showMenu}`);
  }
  searchButton = async (event) => {
    trace('search Button: ' + this.state.searchValue);
    event.preventDefault();
    event.stopPropagation();
    await this.searchCurrent(this.state.searchValue);
  }
  searchButtonSL = async (event) => {
    trace('searchSL Button: ' + this.state.searchValue);
    event.preventDefault();
    event.stopPropagation();
    await this.searchCurrentSL(this.state.searchValue);
  }
  searchButtonSLItem = async (event) => {
    trace('searchSLItem Button: ' + this.state.searchValue);
    event.preventDefault();
    event.stopPropagation();
    await this.searchCurrentSLItem(this.state.searchValue);
  }
  searchButtonOM = async (event) => {
    trace('searchOM Button: ' + this.state.searchValue);
    event.preventDefault();
    event.stopPropagation();
    this.setState({ searchForItems: true });
    await this.searchCurrentOM(this.state.searchValue);
  }
  //----------------------------------------------------------------
  // update Search Values
  //----------------------------------------------------------------
  searchCurrent = async (search) => {
    if (!search || typeof search !== 'string' || search === 'all' || search === 'ALL')
      search = "";
    if (search === undefined)
      search = "";
    trace(`Search for: ${search}`);
    this.itemSearch(search);
  }
  searchCurrentSL = async (search) => {
    if (!search || typeof search !== 'string' || search === 'all' || search === 'ALL')
      search = "";
    if (search === undefined)
      search = "";
    trace(`Search for: ${search}`);
    this.itemSearchSL(search);
  }
  searchCurrentSLItem = async (search) => {
    if (!search || typeof search !== 'string' || search === 'all' || search === 'ALL')
      search = "";
    if (search === undefined)
      search = "";
    trace(`Search for: ${search}`);
    this.itemSearchSLItem(search);
  }
  searchCurrentOM = async (search) => {
    if (!search || typeof search !== 'string' || search === 'all' || search === 'ALL')
      search = "";
    if (search === undefined)
      search = "";
    trace(`OM Search for: ${search}`);
    this.itemOMSearch(search);
  }
  //----------------------------------------------------------------
  // Search Input - Update Search Values
  //----------------------------------------------------------------
  updateSearchValue = async (evt) => { // Original Search Value event handler
    let newValue = evt.value;
    trace(`searchValue: ${this.state.searchValue}, event.value: ${evt.target.value}, ${newValue}, lastSearchValue: ${this.state.lastSearchValue}`);
    if (!(newValue.length > 0 && (newValue[0] === '*' || newValue[0] === '`'))) {
      if (newValue.length >= 2 || this.state.lastSearchValue.length > newValue.length) {
        if (this.addNewItem === true)
          this.setState({ searchForItems: true });
        this.setState({ lastSearchValue: newValue });
        this.itemSearch(newValue);
      }
      else {
        this.setState({ lastSearchValue: newValue });
      }
    }
    this.setState({ searchValue: newValue }); // Note - moved save to State to last operation
  }
  updateSearchSLItemValue = async (evt) => { // Original Search Value event handler
    let newValue = evt.value;
    trace(`searchSLItemValue: ${this.state.searchSLItemValue}, event.value: ${evt.target.value}, ${newValue}, lastSearchSLItemValue: ${this.state.lastSearchSLItemValue}`);
    if (!(newValue.length > 0 && (newValue[0] === '*' || newValue[0] === '`'))) {
      if (newValue.length >= 2 || this.state.lastSearchSLItemValue.length > newValue.length) {
        this.setState({ lastSearchSLItemValue: newValue });
        this.itemSearchSLItem(newValue);
      }
      else {
        this.setState({ lastSearchSLItemValue: newValue });
      }
    }
    this.setState({ searchSLItemValue: newValue }); // Note - moved save to State to last operation
  }
  updateSearchSLValue = async (evt) => { // Original Search Value event handler
    let newValue = evt.value;
    trace(`searchSLValue: ${this.state.searchSLValue}, event.value: ${evt.target.value}, ${newValue}, lastSearchSLValue: ${this.state.lastSearchSLValue}`);
    if (!(newValue.length > 0 && (newValue[0] === '*' || newValue[0] === '`'))) {
      if (newValue.length >= 3 || this.state.lastSearchSLValue.length > newValue.length) {
        this.setState({ lastSearchSLValue: newValue });
        this.itemSearchSL(newValue);
      }
      else {
        this.setState({ lastSearchSLValue: newValue });
      }
    }
    this.setState({ searchSLValue: newValue }); // Note - moved save to State to last operation
  }
  updateOMSearchValue = async (evt) => { // Original Search Value event handler
    let newValue = evt.value;
    trace(`OM searchValue: ${this.state.searchValue}, event.value: ${evt.target.value}, ${newValue}, lastSearchValue: ${this.state.lastSearchValue}`);
    if (!(newValue.length > 0 && (newValue[0] === '*' || newValue[0] === '`'))) {
      if (newValue.length >= 3 || this.state.lastSearchValue.length > newValue.length) {
        if (this.addNewItem === true)
          this.setState({ searchForItems: true });
        this.setState({ lastSearchValue: newValue });
        this.itemOMSearch(newValue);
      }
      else {
        this.setState({ lastSearchValue: newValue });
      }
    }
    this.setState({ searchValue: newValue }); // Note - moved save to State to last operation
  }
  chgItemNameVal = (event) => {
    this.setState({ ItemName: event.target.value });
    this.setState({ searchValue: event.target.value });
    this.setState({ stateHasChanged: true });
    this.setState({ itemChanged: true });
  }
  chgItemDescVal = (event) => {
    this.setState({ ItemDescription: event.target.value });
    this.setState({ stateHasChanged: true });
    this.setState({ itemChanged: true });
  }
  clearSearch = async (event) => { // ClearDisplay, Clear Messages - see updateSearchValue
    trace(`clear search: ${this.state.searchValue}, ${this.state.searchSLValue}, ${this.state.searchSLItemValue}`);
    if (this.state.searchValue !== '') {
      //await this.loadItems(this.ProductItemGroupID);
      this.setState({ searchValue: '' });
      this.setState({ lastSearchValue: '' });
      this.setState({ OrderItems: this.saveOrderItems.slice() });
      this.setState({ searchForItems: false });
    }
    if (this.state.searchSLValue !== '') {
      this.setState({ searchSLValue: '' });
      this.setState({ lastSearchSLValue: '' });
      //trace(`saveShoppingLists: ${JSON.stringify(this.saveShoppingLists)}`);
      this.setState({ ShoppingLists: this.saveShoppingLists.slice() });
    }
    if (this.state.searchSLItemValue !== '') {
      this.setState({ searchSLItemValue: '' });
      this.setState({ lastSearchSLItemValue: '' });
      this.setState({ ShoppingListItems: this.saveShoppingListItems.slice() });
    }
    this.setState({ clearSetAll: true });
    this.setState({ stateHasChanged: true });
  }
  resetOrder = async () => {
    trace(`RESET OrderID: ${SessionInfo.CustomOrderID}, TableName: ${SessionInfo.CurrentTableName}, TotalBill: ${SessionInfo.TotalBill}, PayDone: ${SessionInfo.BillPaymentDone}, BillPaymentComplete: ${SessionInfo.BillPaymentComplete}`);
    this.closePopups(6);
    if (SessionInfo.BillPaymentDone === true) {
      //trace(`TotalBill : ${SessionInfo.TotalBill}, TotalTip: ${SessionInfo.TotalTip}, Order: ${SessionInfo.CustomOrderID}`);
      this.closePopups(12);
      this.setState({ TableName: SessionInfo.CurrentTableName });
      this.setState({ TotalBill: SessionInfo.TotalBill });
      this.setState({ TotalTip: SessionInfo.TotalTip });
      this.setState({ BillCount: SessionInfo.RelatedOrders });
      this.setState({ PaidBills: SessionInfo.PaidOrders });
      this.setState({ TotalQuantity: 0 });
      this.setState({ RatingValue: 0 }); // Set to Default Value
      this.orderIDForComment = SessionInfo.CustomOrderID;
      this.billTimer = 150;
      this.setState({ showBillSummary: true }); // Display the Bill Summary and Feedback popup
      this.forceUpdate();
      SessionInfo.BillPaymentDone = false;
      trace(`BillPayDone - PaidOrders: ${SessionInfo.PaidOrders}, RelatedOrders: ${SessionInfo.RelatedOrders}, BillSummary: ${this.state.showBillSummary}`);
      if (SessionInfo.PaidOrders >= SessionInfo.RelatedOrders)
        SessionInfo.BillPaymentComplete = true; // Flag all Orders Paid
    }
    if (SessionInfo.BillPaymentComplete === true) {
      await this.clearOrderInfo();
    }
  }
  clearOrderInfo = async () => { // clear order, reset order, start fresh
    SessionInfo.ResetOrder = false;
    SessionInfo.CustomOrderID = 0;
    //SessionInfo.ParentOrderID = 0;
    //SessionInfo.SeatCount = 0;
    //SessionInfo.CheckoutPage = undefined;
    //SessionInfo.ShowAllOrders = false;
    //SessionInfo.PayAllOrders = false;
    this.setState({ CustomOrderID: 0 });
    this.setState({ ItemCount: 0 });
    this.setState({ NetItemCount: 0 });
    this.setState({ SubTotalPrice: 0 });
    this.setState({ TotalTaxAmount: 0 });
    this.setState({ TotalPrice: 0 });
    this.setState({ TotalQuantity: 0 });
    this.setState({ selectedItems: undefined });
    this.clearSearch();
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  addStoreItem = async (event,item) => {
    trace(`Not sure this makes any sense - not implemented yet`);
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  addSLItem = async (event,item,rowIdx) => {
    event.stopPropagation();
    trace(`SL item For Item: ${JSON.stringify(item)}`);
    this.cancelAddClick = true;
    let storeItemID = item.StoreItemID;
    let itemName = item.ItemName
    this.setState({ chooseItemName: itemName });
    trace(`addStore SL Item: ${JSON.stringify(item)}, ShoppingListID: ${this.ShoppingListID}`);
    let row = item;
    ShoppingListItemsO.forEach(elem => {
      if (elem.n in row) {
        //console.log(`Set ${elem.n}: ${row[elem.n]}`);
        let sobj = {};
        try {
          if (elem.t === 34 || elem.t === 35) { // Date, DateTime
            sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
            //sobj[elem.n] = row[elem.n];
            SLIV[elem.n] = new Date(row[elem.n]);
          } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = row[elem.n];
            //console.log(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            SLIV[elem.n] = row[elem.n];
          } else if (elem.t === 22) { // Bool
            let val = row[elem.n].toString().charAt();
            if (val === '1' || val === 't' || val === 'T') {
              sobj[elem.n] = true;
              SLIV[elem.n] = true;
            } else {
              sobj[elem.n] = false;
              SLIV[elem.n] = false;
            }
          } else if (elem.t === 23) { // Decimal
            if (elem.n.indexOf('Percent') >= 0 || elem.n.indexOf('Markup') >= 0) {
              sobj[elem.n] = row[elem.n];
              let sobjS = {};
              sobjS[elem.n + 'S'] = moneyFormat(row[elem.n]);
              this.setState(sobjS); // Set the String shadow var
              SLIV[elem.n] = row[elem.n];
            } else { // Decimal
              sobj[elem.n] = row[elem.n];
              SLIV[elem.n] = row[elem.n];
            }
          } else if (elem.t === 28) { // Money
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = moneyFormat(row[elem.n]);
            //console.log(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            SLIV[elem.n] = row[elem.n];
          } else if (elem.t === 41) { // Media - Image or Document
            sobj[elem.n] = row[elem.n];
            SLIV[elem.n] = row[elem.n];
            if (elem.n === 'ImageID')
              currentImageID = row[elem.n];
          } else { // Default - Number
            sobj[elem.n] = row[elem.n];
            SLIV[elem.n] = row[elem.n];
          }
          //console.log(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${SLIV[elem.n]}`);
          if (this.state[elem.n] === undefined)
            console.log(`=== ${elem.n} is not defined in state ===`);
          this.setState(sobj);
          // Add item specific code here
          //if (elem.n === 'ImageID')
          //  ImageID = row[elem.n];
        }
        catch (error) {
          console.log(`Set ShoppingListItemsO Field: ${elem.n}, Error: ${error.message}`);
        }
      }
    });
    // Set default weight and quanity
    if (row.RateTypeID <= 1) { // Each
      this.setState({ Quantity: 1 });
      this.setState({ Weight: 0 });
    } else if (row.RateTypeID == 2) { // Per 100 gms
      this.setState({ Weight: 100 });
      this.setState({ Quantity: 0 });
    } else if (row.RateTypeID == 3) {
      this.setState({ Weight: 500 });
      this.setState({ Quantity: 0 });
    }
    //if (this.addNewItem === true)
    this.setState({ searchForItems: false });
    this.setState({ itemChanged: true }); // This shows Save Item
    if (SLIV.StoreItemID == 0) {
      trace(`itemName: ${SLIV.ItemName}`)
      this.setState({ searchValue: SLIV.ItemName });
      this.setState({ lastSearchValue: SLIV.ItemName });
    } else
      this.setState({ searchValue: "" });
    this.setState({ SearchItems: [] });
    //  this.setState({ displaySLItem: true });
    //  this.setState({ showChangeItems: false });
  }
  addSLQuickItem = async (event,itemName,itemDesc) => {
    event.stopPropagation();
    trace(`SL Quick item For Item: ${this.state.ItemName}, ${this.state.ItemDescription}`);
    let NewSLItem = { "ItemName": this.state.ItemName,"ItemDescription": this.state.ItemDescription,"StoreItemID": 0 };
    let SLQuickItems = this.state.SLQuickItems.slice();
    trace(`SLQuickItems: ${JSON.stringify(SLQuickItems)}`);
    SLQuickItems.unshift(NewSLItem); // Add New Item at the Start of the list    
    trace(`after add - SLQuickItems: ${JSON.stringify(SLQuickItems)}`);
    this.setState({ SLQuickItems });
    this.setState({ ItemName: '' });
    this.setState({ ItemDescription: '' });
    this.itemNameAnchor.current.focus();
  }
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // Show Shopping List Item Detail 
  //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  choiceForSLItem = async (event,item,rowIdx) => {
    event.stopPropagation();
    //trace(`choose For ShoppingList Item: ${JSON.stringify(item)}`);
    this.addNewItem = false;
    this.editSLItem = true;
    this.cancelAddClick = true;
    this.ShoppingListItemID = item.ShoppingListItemID;
    let storeItemID = item.StoreItemID;
    let itemName = item.ItemName
    this.setState({ chooseItemName: itemName });
    trace(`choose SL Item: ${JSON.stringify(itemName)}`);
    // Get Shopping List Item
    let CD = await CallOM("GetShoppingListItem",this.ShoppingListID,this.ShoppingListItemID,0);
    if (CD.x.o === 0 || CD.x.o > 9500) {
      //await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      this.props.navigate("/Login");
    } else {
      trace(`----> SLItem info: ${JSON.stringify(CD.d)}`);
      document.documentElement.style.setProperty('--itemDetailPopupHt',`560px`); // Set Popup Height 
      let SLRow = CD.d; // Shopping List Item 
      if (SLRow) { // Retrieved Value Assignment for: ShoppingListItems
        let row = SLRow;
        ShoppingListItemsO.forEach(elem => {
          if (elem.n in row) {
            //console.log(`Set ${elem.n}: ${row[elem.n]}`);
            let sobj = {};
            try {
              if (elem.t === 34 || elem.t === 35) { // Date, DateTime
                sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
                //sobj[elem.n] = row[elem.n];
                SLIV[elem.n] = new Date(row[elem.n]);
              } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
                sobj[elem.n] = row[elem.n];
                let sobjS = {};
                sobjS[elem.n + 'S'] = row[elem.n];
                //console.log(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
                this.setState(sobjS); // Set the String shadow var
                SLIV[elem.n] = row[elem.n];
              } else if (elem.t === 22) { // Bool
                let val = row[elem.n].toString().charAt();
                if (val === '1' || val === 't' || val === 'T') {
                  sobj[elem.n] = true;
                  SLIV[elem.n] = true;
                } else {
                  sobj[elem.n] = false;
                  SLIV[elem.n] = false;
                }
              } else if (elem.t === 23) { // Decimal
                if (elem.n.indexOf('Percent') >= 0 || elem.n.indexOf('Markup') >= 0) {
                  sobj[elem.n] = row[elem.n];
                  let sobjS = {};
                  sobjS[elem.n + 'S'] = moneyFormat(row[elem.n]);
                  this.setState(sobjS); // Set the String shadow var
                  SLIV[elem.n] = row[elem.n];
                } else { // Decimal
                  sobj[elem.n] = row[elem.n];
                  SLIV[elem.n] = row[elem.n];
                }
              } else if (elem.t === 28) { // Money
                sobj[elem.n] = row[elem.n];
                let sobjS = {};
                sobjS[elem.n + 'S'] = moneyFormat(row[elem.n]);
                //console.log(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
                this.setState(sobjS); // Set the String shadow var
                SLIV[elem.n] = row[elem.n];
              } else if (elem.t === 41) { // Media - Image or Document
                sobj[elem.n] = row[elem.n];
                SLIV[elem.n] = row[elem.n];
                if (elem.n === 'ImageID')
                  currentImageID = row[elem.n];
              } else { // Default - Number
                sobj[elem.n] = row[elem.n];
                SLIV[elem.n] = row[elem.n];
              }
              //console.log(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${SLIV[elem.n]}`);
              if (this.state[elem.n] === undefined)
                console.log(`=== ${elem.n} is not defined in state ===`);
              this.setState(sobj);
              // Add item specific code here
              //if (elem.n === 'ImageID')
              //  ImageID = row[elem.n];
            }
            catch (error) {
              console.log(`Set ShoppingListItemsO Field: ${elem.n}, Error: ${error.message}`);
            }
          }
        });
        this.setState({ displaySLItem: true });
        trace(`====> change StoreItem: ${SLRow.StoreItemID}`);
        if (SLIV.StoreItemID == 0) {
          trace(`itemName: ${SLIV.ItemName}`)
          let searchStr = SLIV.ItemName;
          if (searchStr.length > 10) {
            let idx = searchStr.indexOf(" ",7);
            if (idx > 8)
              searchStr = searchStr.substring(0,idx);
          }
          this.setState({ searchValue: searchStr });
          this.setState({ lastSearchValue: searchStr });
        } else
          this.setState({ searchValue: "" });
        this.setState({ SearchItems: [] });
        this.cancelAddClick = false;
        //await this.displayAddItemToOrder(item,rowIdx,true); // Change
      }
      else
        this.setState({ showChangeItems: false });
    }
  }
  saveSLItem = async () => {
    console.log(`Save Shopping List Item - ShoppingListID: ${this.ShoppingListID}, ItemID: ${this.ShoppingListItemID}, editSLItem: ${this.editSLItem}`);
    let valDict = {};
    //console.log("Save StoreLocation");
    ShoppingListItemsO.forEach((elem) => {
      if (elem.p != 200) { // Don't update on p = 200
        if (elem.n in this.state) {
          if (this.state[elem.n] == undefined) {
            if (elem.t === 34 || elem.t === 35)
              valDict[elem.n] = new Date();
            else if (elem.t === 21 || elem.t === 19 || elem.t === 29) // String, Memo, Enum?
              valDict[elem.n] = '';
            else if (elem.t === 28 || elem.t === 201) { // Money, Enum
              valDict[elem.n] = 0;
            } else if (elem.t === 19) { // Money
              valDict[elem.n] = 0;
            } else if (elem.t === 195) { // Do not clear FK fields on first click
              valDict[elem.n] = 0;
            } else
              valDict[elem.n] = 0;
          }
          else
            valDict[elem.n] = this.state[elem.n];
        }
      }
    });
    //-----------   
    let CD = await CallOM("UpdateShoppingListItem",this.ShoppingListID,this.ShoppingListItemID,CTYP.DICTNO,valDict,0); // Save to OM  
    this.setItemStateChanged(false);
    console.log(`After update ShoppingListID: ${this.ShoppingListID}, ItemID: ${this.ShoppingListItemID}, editSLItem: ${this.editSLItem}`);
    if (this.editSLItem == true) {
      this.editSLItem = false;
      this.cancelSLItem();
    } else
      this.setState({ itemSaved: true });
  }
  addNewSList = async () => {
    this.setState({ inAddSLList: false });
    let valDict = {};
    valDict['ShoppingListName'] = this.state.ShoppingListName;
    valDict['Description'] = this.state.SLDescription;
    valDict['Quantity'] = 1;
    trace(`valDict: ${JSON.stringify(valDict)}`);
    let CD = await CallOM("UpdateShoppingList",0,0,CTYP.DICTNO,valDict,0); // Save to OM
    let ShoppingLists = []; 
    CD = await CallOM("GetShoppingLists",0,0,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`GetShoppingLists CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
      if (CD.d && CD.d.rows)
        ShoppingLists = CD.d.rows;
    }
    this.setState({ ShoppingLists }); 
    this.setItemStateChanged(false);
  }
  saveSList = async () => {
    this.setState({ inAddSLList: false });
    this.setState({ inEditSLList: false });
    let valDict = {};
    valDict['ShoppingListName'] = this.state.ShoppingListName;
    valDict['Description'] = this.state.SLDescription;
    valDict['Quantity'] = 1;
    trace(`valDict: ${JSON.stringify(valDict)}, shoppingListID: ${this.ShoppingListID}`);
    let CD = await CallOM("UpdateShoppingList",0,this.ShoppingListID,CTYP.DICTNO,valDict,0); // Save to OM  
    this.setItemStateChanged(false);
    this.setState({ displayShoppingLists: true });
    this.setState({ displayShoppingList: false });
    // Reload the list     
    let ShoppingLists = [];
    CD = await CallOM("GetShoppingLists",0,0,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`GetShoppingLists CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
      if (CD.d && CD.d.rows)
        ShoppingLists = CD.d.rows;
    }
    this.setState({ ShoppingLists });
  }
  addNewSLItem = async () => {
    this.addNewItem = true;
    this.clearRecord();
    this.setState({ StoreItemID: 0 });
    this.setState({ displaySLQuick: false });
    this.setState({ displaySLItem: true });
  }
  setItemStateChanged = async (status) => {
    this.setState({ itemChanged: status });
  }
  deleteSLItem = async () => {
    //console.log("Delete CustomerProfile: " + this.state.CustomerID);
    let CD = await DeleteRowTry(543619,this.currentCustomerID);
    console.log("Delete Customer - o: " + CD.x.o);
    this.setItemStateChanged(false);
  }
  clearRecord = () => {
    trace(`clear SL Record - ShoppingListID: ${this.ShoppingListID}`);
    ShoppingListItemsO.forEach((elem) => {
      let sobj = {};
      try {
        if (elem.t === 34 || elem.t === 35)
          sobj[elem.n] = new Date();
        else if (elem.t === 21 || elem.t === 19 || elem.t === 29) // String, Memo, Enum? 
          sobj[elem.n] = '';
        else if (elem.t === 28 || elem.t === 201) { // Money, Enum
          sobj[elem.n] = 0;
          let sobjS = {};
          sobjS[elem.n + 'S'] = '';
          this.setState(sobjS);
        } else if (elem.t === 19) { // Money 
          sobj[elem.n] = 0;
          let sobjS = {};
          sobjS[elem.n + 'S'] = '';
        } else if (elem.t === 195) { // Do not clear FK fields on first click
          if (SessionInfo.clearStage === 2)
            sobj[elem.n] = 0;
        } else
          sobj[elem.n] = 0;
        //trace(`sobj: ${JSON.stringify(sobj)}`);
        this.setState(sobj);
      } catch (error) {
        console.log(`Clear Shopping List Field: ${elem.n} Error: ${error.message}`);
      }
    });
    this.setItemStateChanged(false);
    this.setState({ itemSaved: false });
    this.clearScreen = true;
  }
  //-------------------------------------------------------------------------
  async chgMoneyFldVal(event) {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,''); // Matches any single single character not in the bracket [] and replaces with ''  - https://www.infobyip.com/regularexpressioncalculator.php
    //trace(`money newval: ${newVal}, target: ${this.state[event.target.name]}, name: ${event.target.name}`);
    //this.setState({ [event.target.name + 'S']: moneyFormat(newVal) });    
    let tstVal = +newVal;
    if (Number.isNaN(tstVal))
      newVal = event.target.value.replace(/-/g,''); // Remove the - sign
    this.setState({ [event.target.name + 'S']: newVal });
    await this.setState({ [event.target.name]: newVal / 1.0 });
    //trace(`updated target: ${this.state[event.target.name]}, str: ${this.state[event.target.name + 'S']}`);
    this.setState({ stateHasChanged: true });
  }
  chgPercentFldVal(event) {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    //trace("percent newval: " + newVal);
    newVal /= 100.0;
    this.setState({ [event.target.name]: newVal });
    this.setState({ stateHasChanged: true });
  }
  chgDDFldVal = (event) => {
    this.setState({ [event.target.props.name]: event.target.value.ddID });
    this.setState({ stateHasChanged: true });
  }
  chgCheckboxVal(event) {
    let setVal = true;
    if (this.state[event.target.name] === true)
      setVal = false;
    this.setState({ [event.target.name]: setVal });
    this.setState({ stateHasChanged: true });
  }
  chgRateVal = (event) => {
    //trace(`Rate Value: ${event.value}, Name: ${event.target.props.name}`);
    //console.log(event);
    this.setState({ [event.target.props.name]: event.value });
    this.setState({ stateHasChanged: true });
  }
  doneComment = async () => {
    // Save comment and rating
    trace(`Rating: ${this.state.RatingValue}, Comment: ${this.state.ServiceDescription}, OrderID: ${SessionInfo.CustomOrderID}`);
    await CallOM("GuestFeedback",0,this.orderIDForComment,CTYP.TypParm,[TYP.INT,this.state.RatingValue,TYP.STR,this.state.ServiceDescription]);
    this.setState({ showBillSummary: false });
  }
  //
  async blurMoneyFldVal(event) {
    //trace(`money target: ${this.state[event.target.name]}`);
    this.setState({ [event.target.name + 'S']: moneyFormat(this.state[event.target.name]) });
    //trace(`money target: ${this.state[event.target.name + 'S']}`);
  }
  //    
  async focusMoneyFldVal(event) {
    //trace(`money target: ${this.state[event.target.name]}`);
    if (this.state[event.target.name] === 0)
      this.setState({ [event.target.name + 'S']: '' });
    else
      this.setState({ [event.target.name + 'S']: this.state[event.target.name] });
    //trace(`money target: ${this.state[event.target.name + 'S']}`);
  }
  async chgMoneyFldValD(event) {
    this.setState({ TipAmountOverPS: '' });
    this.setState({ TipAmountOverP: 0.0 });
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,''); // Matches any single single character not in the bracket [] and replaces with ''  - https://www.infobyip.com/regularexpressioncalculator.php
    //trace(`money newval: ${newVal}, target: ${this.state[event.target.name]}, name: ${event.target.name}`);
    //this.setState({ [event.target.name + 'S']: moneyFormat(newVal) });    
    let tstVal = +newVal;
    if (Number.isNaN(tstVal))
      newVal = event.target.value.replace(/-/g,''); // Remove the - sign
    this.setState({ TipAmountOverDS: newVal });
    await this.setState({ TipAmountOverD: newVal / 1.0 });
    //trace(`updated target: ${this.state[event.target.name]}, str: ${this.state[event.target.name + 'S']}`);
    this.setState({ stateHasChanged: true });
  }
  itemSearch = async (srchStr) => { // Search for Match
    trace(`ItemSearch - search: ${srchStr}, lth: ${srchStr.length}`);
    //trace(`saveOrderItems: ${JSON.stringify(this.saveOrderItems)}`);
    this.closePopups(3);
    if (srchStr.length > 2) {
      this.comp2Update = false; // Stop Updates
      let OrderItems = [];
      let cnt = 0;
      let cats = [];
      let groupSwitch = false;
      try {
        let srch = new RegExp(srchStr,"i"); // case insensitive
        this.state.OrderItems.forEach(row => {
          //trace(`search idx: ${row.ItemName.search(srchStr)}, name: ${row.ItemName}, ItemDesc: ${row.ItemDescription.search(srchStr)}, Desc: ${row.ItemDescription}`);
          //trace(`search row: ${JSON.stringify(row)}`);
          if (row.ItemName.search(srch) >= 0) {
            OrderItems.push(row);
            cnt++
          } else if (row.ItemDescription.search(srch) >= 0) {
            OrderItems.push(row);
            cnt++
          }
        });
        this.comp2Update = true; // Start Updates
      } catch (ex) {
        console.error(`itemSearch error: ${ex}`);
      }
      trace(`StoreItem match: ${cnt}`);
      if (cnt === 0) {
        this.setState({ OrderItems: this.saveOrderItems });
      } else {
        //trace(`OrderItems: ${JSON.stringify(OrderItems)}`);
        this.setState({ OrderItems });
      }
    } else { // ALL
      this.setState({ OrderItems: this.saveOrderItems });
    }
  }
  itemSearchSL = async (srchStr) => { // Search for Match
    trace(`ItemSearchSL - search: ${srchStr}, lth: ${srchStr.length}`);
    this.closePopups(3);
    if (srchStr.length > 2) {
      this.comp2Update = false; // Stop Updates
      let ShoppingLists = [];
      let cnt = 0;
      try {
        let srch = new RegExp(srchStr,"i"); // case insensitive
        this.state.ShoppingLists.forEach(row => {
          //trace(`search idx: ${row.ItemName.search(srchStr)}, name: ${row.ItemName}, ItemDesc: ${row.ItemDescription.search(srchStr)}, Desc: ${row.ItemDescription}`);
          //trace(`search row: ${JSON.stringify(row)}`);
          if (row.ShoppingListName.search(srch) >= 0) {
            ShoppingLists.push(row);
            cnt++
          } else if (row.Description.search(srch) >= 0) {
            ShoppingLists.push(row);
            cnt++
          }
        });
        this.comp2Update = true; // Start Updates
      } catch (ex) {
        console.error(`ShoppingLists Search error: ${ex}`);
      }
      trace(`ShoppingLists match: ${cnt}`);
      if (cnt === 0) {
        this.setState({ ShoppingLists: this.saveShoppingLists.slice() });
      } else {
        //trace(`OrderItems: ${JSON.stringify(OrderItems)}`);
        this.setState({ ShoppingLists });
        //this.saveShoppingLists = ShoppingLists.slice();
      }
    } else { // ALL
      trace(`Shopping Lists: ${JSON.stringify(this.saveShoppingLists)}`);
      this.setState({ ShoppingLists: this.saveShoppingLists.slice() });
    }
  }
  itemSearchSLItem = async (srchStr) => { // Search for Match
    //trace(`ShoppingListItems - search: ${srchStr}, lth: ${srchStr.length}`);
    this.closePopups(3);
    if (srchStr.length >= 2) {
      this.comp2Update = false; // Stop Updates
      let ShoppingListItems = [];
      let cnt = 0;
      try {
        let srch = new RegExp(srchStr,"i"); // case insensitive
        this.state.ShoppingListItems.forEach(row => {
          //trace(`search idx: ${row.ItemName.search(srchStr)}, name: ${row.ItemName}, ItemDesc: ${row.ItemDescription.search(srchStr)}, Desc: ${row.ItemDescription}`);
          //trace(`search row: ${JSON.stringify(row)}`);
          if (row.ItemName.search(srch) >= 0) {
            ShoppingListItems.push(row);
            cnt++
          } else if (row.ItemDescription.search(srch) >= 0) {
            ShoppingListItems.push(row);
            cnt++
          }
        });
        this.comp2Update = true; // Start Updates
      } catch (ex) {
        console.error(`itemSearchSLItem error: ${ex}`);
      }
      trace(`itemSearchSLItem match: ${cnt}`);
      if (cnt === 0) {
        this.setState({ ShoppingListItems: this.saveShoppingListItems });
      } else {
        //trace(`OrderItems: ${JSON.stringify(OrderItems)}`);
        this.setState({ ShoppingListItems });
      }
    } else { // ALL
      this.setState({ ShoppingListItems: this.saveShoppingListItems });
    }
  }
  itemOMSearch = async (srchStr) => {
    trace(`itemOMSearch: ${srchStr}, location: ${SessionInfo.StoreLocationID}`);
    let CD = await CallOM("SearchStoreItems",SessionInfo.StoreLocationID,0,CTYP.STR,srchStr,'',0); // Search for Items - no image
    //trace(`Search Items: ${JSON.stringify(CD)}`);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      try {
        if (CD.d) {
          this.setState({ SearchItems: CD.d.rows.map(dataItem => Object.assign({ selected: false },dataItem)) });
          trace(`Selected Items: ${JSON.stringify(CD.d)}`); // Current List of Selected Items
        } else
          this.setState({ SearchItems: [] });
      } catch (ex) {
        console.log(`Error in itemOMSearch: ${ex}`);
      }
    }
  }
  cancelDetailAdd = () => { // Note 6Jun23 - Need to hide popup
    this.CustomOrderItemID = -1;
    this.setState({ displayItemDetail: false });
  }
  cancelSLItem = async () => {
    let CD = await CallOM("GetShoppingListItems",0,this.ShoppingListID,0); // Update List of Items
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      if (CD.d && CD.d.rows) {
        this.setState({ ShoppingListItems: CD.d.rows });
        this.saveShoppingListItems = CD.d.rows;
      }
    } 
    document.documentElement.style.setProperty('--itemDetailPopupHt',`800px`); // Reset Popup Height 
    this.setState({ searchValue: "" });
    this.setState({ displaySLItem: false });
  }
  SaveSLQuickItems = async () => {
    console.log(`Save Shopping List Item - ShoppingListID: ${this.ShoppingListID}, ItemID: ${this.ShoppingListItemID}`);
    let NewSLItem = {};
    let CD;
    let rows = this.state.SLQuickItems;
    let count = this.state.SLQuickItems.length;
    for (let ix = 0; ix < count; ix++) {
      NewSLItem = { "ShoppingListItemID": 0,"ItemName": rows[ix].ItemName,"ItemDescription": rows[ix].ItemDescription,"StoreItemID": 0 }; 
      trace(`SL Quick item For Item: ${rows[ix].ItemName}, ${rows[ix].ItemDescription}`);
      CD = await CallOM("UpdateShoppingListItem",this.ShoppingListID,0,CTYP.DICTNO,NewSLItem,0); // Save to OM 
    }
    this.setState({ SLQuickItems : [] });
    //-----------   
  }
  finshSLQuickItem = async () => {
    await this.SaveSLQuickItems();
    let CD = await CallOM("GetShoppingListItems",0,this.ShoppingListID,0); // Update List of Items
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      if (CD.d && CD.d.rows) {
        this.setState({ ShoppingListItems: CD.d.rows });
        this.saveShoppingListItems = CD.d.rows;
      }
    }
    document.documentElement.style.setProperty('--itemDetailPopupHt',`800px`); // Reset Popup Height 
    this.setState({ searchValue: "" });
    this.setState({ displaySLQuick: false });
  }
  gotoDetailEntry = async () => {
    this.setState({ displaySLQuick: false });
    this.setState({ displaySLItem: true });
  }
  useShoppingList = async () => {
    this.setState({ displayShoppingList: false });
    trace(`use SL - CustomOrderID: ${SessionInfo.CustomOrderID}, ShoppingListID: ${this.ShoppingListID}`);
    let CD = await CallOM("ShoppingListSetup",SessionInfo.CustomOrderID,this.ShoppingListID,0,'','',SessionInfo.StoreLocationID); // Bring shopping List to Scanner List
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`ShoppingList Use Items CD: ${JSON.stringify(CD.d.rows)}`);
      if (CD.d && CD.d.rows) {
        this.setState({ ShoppingListItems: CD.d.rows });
        this.saveShoppingListItems = CD.d.rows;
        if (this.saveShoppingListItems.length > 0) {
          const OrderItems = CD.d.rows.map(dataItem => Object.assign({ selected: false },dataItem));
          SessionInfo.CustomOrderID = OrderItems[0].CustomOrderID;
          this.setState({ OrderItems });
          trace(`ShoppingList Use Items CD: ${JSON.stringify(OrderItems)}`);
          this.saveOrderItems = OrderItems.slice();
          //await this.getOrderItemRecords();
        }
        else
          console.log(`No OrderItems returned from ShoppingList: ${this.ShoppingListID}`);
        await this.getCurrentTotal();
      }
    }
  }
  cancelShoppingList = () => {
    this.setState({ displayShoppingLists: true });
    this.setState({ displayShoppingList: false });
    this.setState({ inAddSLList: false });
    this.setState({ inEditSLList: false });
  }
  cancelShoppingLists = () => {
    this.setState({ displayShoppingLists: false });
  }
  useSLQuick = async () => {
    trace(`use SL - CustomOrderID: ${SessionInfo.CustomOrderID}, ShoppingListID: ${this.ShoppingListID}`);
    let CD = await CallOM("ShoppingListSetup",SessionInfo.CustomOrderID,this.ShoppingListID,0,'','',SessionInfo.StoreLocationID); // Bring shopping List to Scanner List
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`ShoppingList Use Items CD: ${JSON.stringify(CD.d.rows)}`);
      if (CD.d && CD.d.rows) {
        this.setState({ ShoppingListItems: CD.d.rows });
        this.saveShoppingListItems = CD.d.rows;
        if (this.saveShoppingListItems.length > 0) {
          const OrderItems = CD.d.rows.map(dataItem => Object.assign({ selected: false },dataItem));
          SessionInfo.CustomOrderID = OrderItems[0].CustomOrderID;
          this.setState({ OrderItems });
          trace(`ShoppingList Use Items CD: ${JSON.stringify(OrderItems)}`);
          this.saveOrderItems = OrderItems.slice();
          //await this.getOrderItemRecords();
        }
        else
          console.log(`No OrderItems returned from ShoppingList: ${this.ShoppingListID}`);
        await this.getCurrentTotal();
      }
    }
    this.setState({ ItemName: '' });
    this.setState({ ItemDescription: '' });
    this.setState({ displaySLQuick: true });
    this.setState({ displaySLItem: false });
  }
  chgFldVal = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ stateHasChanged: true });
    this.setState({ itemChanged: true });
  }
  chgMoneyFldVal = (event) => {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    this.setState({ [event.target.name]: newVal });
  }
  chgPercentFldVal = (event) => {
    //var stateCopy = Object.assign({}, this.state[event.target.name]);
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    //trace("percent newval: " + newVal);
    newVal /= 100.0;
    this.setState({ [event.target.name]: newVal });
    this.setState({ stateHasChanged: true });
  }
  chgDDFldVal = (event) => {
    this.setState({ [event.target.props.name]: event.target.value.ddID });
    this.setState({ stateHasChanged: true });
  }
  chgCheckboxVal = (event) => {
    let setVal = true;
    if (this.state[event.target.name] === true)
      setVal = false;
    this.setState({ [event.target.name]: setVal });
    this.setState({ stateHasChanged: true });
  }
  changeQuantity = (e) => {
    trace(`changeQuantity: ${e.target.value}, Existing Qty: ${this.ExistQty}, change: ${this.state.isItemChange}, status: ${this.state.OrderItemStatus}`); //JSON.stringify(e));
    let newQuantity = e.target.value;
    this.setState({ itemChanged: true });
    this.setState({ Quantity: newQuantity });
    let TotalPrice = this.state.Price * newQuantity;
    trace(`change Quantity: ${newQuantity}, TotalPrice: ${TotalPrice}`); //JSON.stringify(e));
    this.setState({ TotalPrice });
  }
  changeWeight = (e) => {
    trace(`changeWeight: ${e.target.value}, Existing Qty: ${this.ExistQty}, change: ${this.state.isItemChange}, status: ${this.state.OrderItemStatus}`); //JSON.stringify(e));
    let newWeight = e.target.value;
    this.setState({ itemChanged: true });
    this.setState({ Weight: newWeight });
    trace(`change Weight: ${newWeight}`); //JSON.stringify(e));
    let TotalPrice;
    if (this.state.RateTypeID === 2)
      TotalPrice = this.state.Price * newWeight / 100.0;
    else if (this.state.RateTypeID === 3)
      TotalPrice = this.state.Price * newWeight / 500.0;
    this.setState({ TotalPrice });
  }
  changeItemWeight = (e) => {
    trace(`changeWeight: ${e.target.value}, Existing Qty: ${this.ExistQty}, change: ${this.state.isItemChange}, status: ${this.state.OrderItemStatus}`); //JSON.stringify(e));
    let newWeight = e.target.value;
    this.setState({ itemChanged: true });
    this.setState({ Weight: newWeight });
    trace(`change Weight: ${newWeight}`); //JSON.stringify(e));
    let TotalPrice;
    if (this.state.RateTypeID === 2)
      TotalPrice = this.state.ItemPrice * newWeight / 100.0;
    else if (this.state.RateTypeID === 3)
      TotalPrice = this.state.ItemPrice * newWeight / 500.0;
    this.setState({ TotalPrice });
  }
  changeItemOnOrder = async () => {
    trace(`Change - AllOptionsDone: ${this.AllOptionsDone}, optionCount: ${this.OptionCount}, itemCount: ${this.state.Quantity}`);
    if (this.state.Quantity <= 0) {
      await this.deleteOrderItem();
      this.setState({ displayItemDetail: false });
      this.fetchTableInfo(); // Setup Initial Table Info
    } else {
      await this.changeOrderItem();
      this.setState({ displayItemDetail: false });
      this.fetchTableInfo(); // Setup Initial Table Info
    }
  }
  changeOrderItem = async () => {
    let CD;
    let OrderItemID = this.CustomOrderItemID;
    let SelectedOptions = 0;
    for (let ix = 0; ix < this.OptionCount; ix++) {
      for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
        if (this.state.Options[ix][ox].Select === true)
          SelectedOptions++;
      }
    }
    trace(`---> Change OrderItem - CustomOrderID: ${SessionInfo.CustomOrderID}, CustomOrderItemID: ${this.CustomOrderItemID}, Quantity: ${this.state.Quantity}, OptionCount: ${SelectedOptions} `);
    try {
      if (SessionInfo.CustomOrderID > 0 && this.CustomOrderItemID > 0) { // This should ALWAYS be the case on a change
        CD = await CallOMT("AddUpdateOrderItem",TYP.INT,SessionInfo.CustomOrderID,TYP.INT,this.CustomOrderItemID,TYP.INT,this.StoreItemID,TYP.DEC,this.state.OptionsPrice,TYP.INT,SelectedOptions,TYP.DEC,this.state.Quantity,TYP.DEC,this.state.Weight,TYP.STR,this.state.SpecialInstruction);
        if (CD.x.o === 0) {
          await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
          this.CustomOrderItemID = -2;
        }
        else if (CD.x.o < 9500) {
          //trace(`changeOrderItem - AddUpdateOrderItem return data: ${JSON.stringify(CD.d)}`);
          OrderItemID = CD.d["CustomOrderItemID"];
        }
        else {
          this.CustomOrderItemID = -3;
        }
        CD = await CallOM("DeleteOrderItemOptions",0,this.CustomOrderItemID,0);
        trace(`OrderItemID: ${OrderItemID}`);
        if (OrderItemID > 0) {
          trace(`OptionCount: ${this.OptionCount}`); // OptionCount is the number of Option Groups
          for (let ix = 0; ix < this.OptionCount; ix++) {
            //trace(`Options Lth: ${this.state.Options[ix].length}`);
            for (let ox = 0; ox < this.state.Options[ix].length; ox++) {
              //trace(`option - ix:${ix}, ox:${ox}, key:${this.optionKeys[ix]} option: ${JSON.stringify(this.state.Options[ix][ox])}`);
              if (this.state.Options[ix][ox].Select === true) {
                CD = await CallOMT("AddOrderItemOption",TYP.INT,this.StoreItemID,TYP.INT,OrderItemID,TYP.INT,this.optionKeys[ix],TYP.INT,this.state.Options[ix][ox].ID,TYP.DEC,-1,TYP.DEC,1,TYP.DEC,0); // Quantity, Price, Weight -> Price -1 means look it up
              }
            }
          }
        }
      }
    } catch (error) {
      await OMTrace(2,`Failure in changeOrderItem - Error: ${error}`);
    }
    return CD;
  }
  fetchTableInfo = async () => {
    trace(`====> fetchTableInfo - pauseGoTo: ${SessionInfo.PauseOPMonitor}, CustomOrderID: ${SessionInfo.CustomOrderID}`);
    if (SessionInfo.PauseOPMonitor === false && SessionInfo.CustomOrderID > 0) {
      this.fetchInProcess = true;
      this.fetchCount = 0;;
      let CD = await CallOM("GetTableInfoForOrder",1,SessionInfo.CustomOrderID,0); // This gets Total and Seat Information for the table - not orderItems - see getCurrentTotal below - or GetCustomOrderTotal
      trace(`---> TableInfo: ${JSON.stringify(CD.d)}, o: ${CD.x.o}, orderID: ${SessionInfo.CustomOrderID}`);
      if (CD.x.o === 0 || CD.x.o >= 9500)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else {
        if (CD.d && CD.d !== null) {
          try {
            trace(`Status: ${CD.d.Status}, Seat: ${CD.d.SeatName}, Count: ${CD.d.SeatCount}`)
            //trace(`CD.d: ${JSON.stringify(CD.d)}`);
            this.setState({ StoreName: CD.d.LocationName });
            if (CD.d.Status >= 10) { // Order is complete
              SessionInfo.BillPaymentDone = true;
              SessionInfo.BillPaymentComplete = true;
              SessionInfo.firstOrderComplete = true;
              await this.resetOrder();
            } else {
              SessionInfo.CurrentOrderCustomerID = CD.d.CustomerID;
              if (this.state.TableName !== CD.d.TableName)
                this.setState({ TableName: CD.d.TableName });
              if (SessionInfo.CurrentSeat === '') {
                if (this.state.SeatName !== CD.d.SeatName) {
                  this.setState({ SeatName: CD.d.SeatName });
                  SessionInfo.SeatName = CD.d.SeatName;
                }
              }
              if (this.state.SeatCount !== CD.d.SeatCount) {
                this.setState({ SeatCount: CD.d.SeatCount });
                SessionInfo.SeatCount = CD.d.SeatCount;
              }
              //trace(`Check Order has Changed - TotalPrice: ${this.state.TotalPrice},${typeof this.state.TotalPrice} Owe: ${CD.d.Owe},${typeof CD.d.Owe}`);
              if (this.state.TotalPrice !== CD.d.Owe) {
                trace(`Order has Changed - Order Status: ${CD.d.Status}, Seat: ${CD.d.SeatName}, Count: ${CD.d.SeatCount}, TotalPrice: ${this.state.TotalPrice},${typeof this.state.TotalPrice} Owe: ${CD.d.Owe},${typeof CD.d.Owe}`);
                // Fetch the current items
                await this.getOrderItemRecords();
                await this.getCurrentTotal(); // Get current totals and selectedItems
                trace(`load (3) - fetchTableInfo - selectedItems: ${JSON.stringify(this.state.selectedItems)}`);
              }
            }
            //trace(`SeatCount: ${this.state.SeatCount}, Session SC: ${SessionInfo.SeatCount}`);
          } catch (error) {
            await OMTrace(2,`Failure in fetchTableInfo - Error: ${error}`);
          }
        }
        else {
          SessionInfo.CustomOrderID = 0;
        }
      }
    } else {
      let location = parseInt(SessionInfo.StoreLocationID);
      if (Number.isInteger(SessionInfo.CurrentTableID) === false)
        SessionInfo.CurrentTableID = 0;
      let table = parseInt(SessionInfo.CurrentTableID);
      trace(`GetLocationInfo: location: ${location}, table: ${table}`);
      let CD = await CallOM("GetLocationInfo",location,table,0);
      if (!CD || !CD.d)
        await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
      else {
        trace(`LocationInfo: ${JSON.stringify(CD)}`);
        this.setState({ StoreName: CD.d.StoreName });
        this.setState({ TableName: CD.d.TableName });
      }
    }
    this.fetchInProcess = false;
    this.fetchCount = 0;
  }
  ClearMessage = async () => { // ClearDisplay, Clear Messages
    //trace("ClearMessage Pressed - for: " + SessionInfo.currentPage);
    this.setState({ MessagesValue: '' });
    SessionInfo.message = ''; // MessagesValue is set to SessionInfo.message in the Timer loop  
    this.setState({ showPopup: false });
  }
  PopupMessage = async () => {
    // Keep this code for example
    //var tag = document.createElement('div');
    //var newString = this.state.MessagesValue.replace(/<br\/>/g, "XXX");
    //trace("newString: " + newString);
    //tag.innerHTML = newString;
    //newString = tag.innerHTML.replace(/XXX/g, "&#10;");  
    //trace("newString: " + newString);
    //this.setState({ MessagesText: newString });
    if (this.state.showPopup === false)
      this.popupTimer = 50;
    else
      this.popupTimer = 0;
    this.setState({ showPopup: !this.state.showPopup });
    //this.setState({ dialogVisible: true });
  }
  //------------------------- Image Processing ------------------------------------------------------------------
  captureImageRef = () => this.inputReference.current.click();

  captureImage = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    trace("File: " + JSON.stringify(file));
    let ImageType = GetFileExtension(file.name);
    trace("ImageType: " + ImageType);
    ImageType = ImageType.toLowerCase();
    this.setState({ ImageType });
    let imageURL = URL.createObjectURL(file);
    this.setState({ PersonPhotoURL: imageURL });
    //this.setState({ ContractFileName: file.name });
    let reader = new window.FileReader();
    try {
      reader.readAsArrayBuffer(file);
      reader.onloadend = () => this.convertToBuffer(reader);
      displayMessage("Image: " + file.name + " Loaded");
    }
    catch (error) {
      trace("FileReader Error: " + error);
      displayError("Error on Image Read");
    } //catch      
    let ix = this.state.DocumentTypes.findIndex(c => c.ddName === ImageType);
    if (ix >= 0)
      this.setState({ DocumentTypeID: this.state.DocumentTypes[ix].ddID });
    else
      displayWarning("Unknown file type: " + ImageType);
  }
  convertToBuffer = async (reader) => { // File is converted to a buffer to prepare for uploading to OM
    const UploadFile = await Buffer.from(reader.result);
    //set this buffer -using es6 syntax          
    this.setState({ UploadFile });
    trace("UploadFile Length: " + UploadFile.length);
    await this.saveImageToServer(UploadFile);
  };
  GetItemImage = async (imageID) => {
    //trace("GetProductItemImage ID: " + imageID);
    let imageURL = await getImageFileFromServer(imageID);
    trace(`GetProductItemImage URL: ${imageURL}`);
    return imageURL;
  }
  GetProductItemImage = async (imageID) => {
    //trace("GetProductCategoryImage ID: " + imageID);
    let imageURL = await getImageFileFromServer(imageID);
    this.setState({ ProductItemPhotoURL: imageURL });
  }
  saveProductItemImageToServer = async (event) => {
    await this.saveImageToServer(this.StoreItemTableObjID,this.state.StoreItemID);
  }
  storeItemsPageChange = (event) => {
    this.setState({ storeItemsSkip: event.page.skip,storeItemsTake: event.page.take });
  }

  saveImageToServer = async (uploadFile) => {
    trace('saveImageToServer: ');
    if (this.isSavingDocument) {
      displayMessage("Document Save in Progress");
      return;
    }
    else if (!uploadFile)
      displayError('A file must be selected');
    else {
      this.isSavingDocument = true;
      displayMessage('Saving Image');
      //trace("Save Image " + JSON.stringify(this.state.UploadFile));
      //let type = this.state.UploadFile.type;  // THIS does not work - I don't understand why??
      //let buff = this.state.UploadFile.data;
      //trace("type " + JSON.stringify(type));
      //trace("buff " + JSON.stringify(buff));   
      //CDATA CD = await AccessOM.CallOM("SaveCustomerProfileImage", 0, 0, 0, NewImage);
      await CallOM("SaveCustomerProfileImage",0,0,20,uploadFile,this.state.ImageType); // 17
      trace("Saved Image " + this.state.UploadFile.length);
      this.isSavingDocument = false;
    }
  }
  onCheckout = () => {
    //trace(`Goto CheckoutPage - CustomOrderID: ${SessionInfo.CustomOrderID}`);
    if (this.state.TotalPrice > 0) {
      //trace(`Goto CheckoutPage - CustomOrderID: ${SessionInfo.CustomOrderID}`);
      SessionInfo.PauseOPMonitor = true;
      //trace(`onCheckout - pauseGoTo: ${SessionInfo.PauseOPMonitor}`);
      this.props.navigate("/CheckoutPage");
    }
    else {
      displayMessage("Add some Items to your Order");
      //displayError(`No Items Added For Checkout (${moneyFormat(this.state.TotalPrice)})`);
    }
  }
  //------------------------- ShoppingList ----------------------------------------------------------------------------------------------------------------------------
  openLists = async () => {
    this.closePopups(7);
    document.documentElement.style.setProperty('--itemDetailPopupHt',`800px`); // Reset Popup Height 
    let ShoppingLists = [];
    let CD = await CallOM("GetShoppingLists",0,0,0);
    if (CD.x.o === 0)
      await LogOffResetMsg(`Web Session Has Failed in ${SessionInfo.currentPage} - Session: ${CD.x.s}`,1);
    else if (CD.x.o < 9500) {
      trace(`GetShoppingLists CD.o: ${CD.x.o}  d: ${JSON.stringify(CD.d)}`);
      if (CD.d && CD.d.rows)
        ShoppingLists = CD.d.rows;
    }
    this.setState({ ShoppingLists });
    this.saveShoppingLists = ShoppingLists.slice();
    this.setState({ displayShoppingLists: true });
    trace(`open List`);
  }
  scrollSList = (event) => { // scroll the Shopping List when too tall to fit in popup
    // console.log(event.currentTarget.scrollTop); - scroll position
    //trace(`Scroll Options - hideImage: ${this.hideItemImage}, stopScroll: ${this.stopScroll}`);
    //if (this.hideItemImage === false && this.stopScroll === false) {
    //  //if (this.scrollPopup === true)
    //  this.hideImage();
    //} // Note 27Sep24 - there is a problem if the options almost fit - so you scroll and it removes the image - which puts the scrollTop back to 0 which shows the image and then it doesn't fit
    //this.stopScroll = false;
    //  else if (event.currentTarget.scrollTop === 0) {
    //    this.showImage();
    //  }
  }
  scrollSLItem = (event) => { // scroll the Shopping Item search List when too tall to fit in popup
    // console.log(event.currentTarget.scrollTop); - scroll position
    //trace(`Scroll Options - hideImage: ${this.hideItemImage}, stopScroll: ${this.stopScroll}`);
    //if (this.hideItemImage === false && this.stopScroll === false) {
    //  //if (this.scrollPopup === true)
    //  this.hideImage();
    //} // Note 27Sep24 - there is a problem if the options almost fit - so you scroll and it removes the image - which puts the scrollTop back to 0 which shows the image and then it doesn't fit
    //this.stopScroll = false;
    //  else if (event.currentTarget.scrollTop === 0) {
    //    this.showImage();
    //  }
  }
  //------------------------- ShoppingList Template ----------------------------------------------------------------------------------------------------------------------------
  ShoppingListItemsHeader = () => {
    return (
      <ListViewHeader className='listSLHeader'>
        <span >Shopping List Items </span>
      </ListViewHeader>
    );
  }
  ShoppingListItemsFormat = props => {
    let rowIdx = 1; // props.index;
    let item = props.dataItem;
    //trace(`OrderItemFormat - item: ${JSON.stringify(item)}`);
    item.RateDesc = '';

    return (
      <div>
        <div className="listSLScanRow57" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listSLSText">
            <span className="listScanItemName">{item.ItemName}
            </span><br />
            <p className="listScanItemDesc">{item.ItemDescription}</p>
          </div>
          <div className="listSLBuyDiv">
            {item.RateTypeID > 1 ?
              <>
                <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
                <span className="listScanWht">{item.Weight} grams</span>
              </>
              :
              <>
                {item.ItemPrice > 0 ?
                  <>
                    <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
                    {item.Quantity > 1 ?
                      <span className="listScanCount" > &nbsp; x {item.Quantity}</span> : null}
                  </> : null}
              </>}
            {item.TotalPrice > 0 ?
              <span className="listScanTotal" >{moneyFormat(item.TotalPrice)} &nbsp;</span> : null}
            <div className="listScanEditDelete">
              {this.state.searchForItems ?
                <>
                  <CartAdd alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.addSLItem(e,item,rowIdx)} />
                </>
                :
                <>
                  <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.choiceForSLItem(e,item,rowIdx)} />
                  <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="listScanBtn2" onClick={(e) => this.verifyRemoveSLItem(e,item)} />
                  {SessionInfo.AC.HasPromotion && item.IsPromotion ?
                    <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML1" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
                </>}
            </div>
          </div>
        </div>
      </div>
    );
  }
  ShoppingListItemsFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listSLFooter'>
        <div style={{ left: '20px' }}>
          {/*<span> &nbsp; &nbsp; &nbsp;Receipts Total: &nbsp;</span>*/}
          {/*<span style={{ fontWeight: 'bold' }}>{moneyFormat(this.state.TotalReceiptsPrice)}</span>*/}
          <br />
        </div>
      </ListViewFooter>
    );
  }
  //------------------------- ShoppingLists Template ----------------------------------------------------------------------------------------------------------------------------
  ShoppingListsHeader = () => {
    return (
      <ListViewHeader className='listSLsHeader'>
        <span >Shopping Lists </span>
      </ListViewHeader>
    );
  }
  ShoppingListsFormat = props => {
    let item = props.dataItem;
    let iDate = new Date(item.LastUsedOn);

    return (
      <div className="listSLsRow" onClick={(e) => this.displayAShoppingList(item)}>
        <div id="listSLsRowName">
          <span style={{ fontWeight: 'bold' }}>{item.ShoppingListName}&nbsp;</span><br /><span>{item.Description}</span>
        </div>
        <div id="listSLsRowDelete"> 
          {/* 12Mar25 - THIS NEEDS TO BE INVESTIGATED - Edit does not work*/ }
          <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ShoppingListName}`} className="listScanBtn2" onClick={(e) => this.verifyRemoveSL(e,item)} />
          <CartEdit alt="" fill={SessionInfo.activeColor} stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit ${item.ShoppingListName}`} className="listScanBtn1" onClick={(e) => this.displayEditShoppingList(e,item)} />
        </div>
        <div id="listSLsRowCount">
          <span>Item Count: {item.ItemCount} &nbsp; </span>
          <span> &nbsp; Used Count: {item.UsedCount}</span>
          <br />
          {iDate > SessionInfo.cutoffDate ?
            <span>Last Used: {dateFormat(item.LastUsedOn)}</span> : <span>Never Used</span>}
        </div>
      </div>
    );
  }
  ShoppingListsFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listSLsFooter'>
        <div style={{ left: '20px' }}>
          {/*<span> &nbsp; &nbsp; &nbsp;Receipts Total: &nbsp;</span>*/}
          {/*<span style={{ fontWeight: 'bold' }}>{moneyFormat(this.state.TotalReceiptsPrice)}</span>*/}
          <br />
        </div>
      </ListViewFooter>
    );
  }
  //
  //ShoppingListItemsFormat = props => {
  //  let rowIdx = 1; // props.index;
  //  let item = props.dataItem;
  //  //trace(`OrderItemFormat - item: ${JSON.stringify(item)}`);
  //  item.RateDesc = '';

  //  return (
  //    <div>
  //      <div className="listScanRow" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
  //        <div className="listSLSText">
  //          <span className="listScanItemName">{item.ItemName}&nbsp;&nbsp;
  //          </span><br />
  //          <p className="listScanItemDesc">{item.ItemDescription}</p>
  //        </div>
  //        <div className="listSLBuyDiv">
  //          {item.RateDesc != '' ?
  //            <>
  //              <span>{moneyFormat(item.Price)}</span> <br style={{ lineHeight: '0px',}} />
  //              <span className="listScanWht">{item.Weight} grams</span>
  //            </>
  //            :
  //            <>
  //              <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
  //              <span className="listScanCount" > &nbsp; x {item.Quantity}</span>
  //            </>}
  //          {item.TotalPrice > 0 ?
  //            <span className="listScanTotal" >{moneyFormat(item.TotalPrice)} &nbsp;</span> : null}
  //          {SessionInfo.AC.HasShoppingCart ?
  //            <div className="listSLEditCart">
  //              <CartEdit alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Edit or Delete Item ${item.ItemName}`} className="listScanBtn1" onClick={(e) => this.choiceForSLItem(e,item,rowIdx)} />
  //              <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="listScanBtn2" onClick={(e) => window.confirm(`Delete ${item.ItemName.trimRight()}?`) && this.onDeleteItem(item)} />
  //              {SessionInfo.AC.HasPromotion && item.IsPromotion ?
  //                <Promotion alt="" fill={SessionInfo.attnColor} id="ShowPromoBtn" title={`There is a Promotion for ${item.ItemName}`} className="listOMPromoML1" onClick={(e) => this.addShowPromotion(e,item,rowIdx)} /> : null}
  //            </div> : null}
  //        </div>
  //      </div>
  //    </div>
  //  );
  //}
  //--------------- SL Fast ----------------------------------------------------------------------------------------
  SLQuickItemsHeader = () => {
    return (
      <ListViewHeader className='listSLHeader'>
        <span >Shopping List Items </span>
      </ListViewHeader>
    );
  }
  SLQuickItemsFormat = props => {
    let rowIdx = 1; // props.index;
    let item = props.dataItem;
    //trace(`OrderItemFormat - item: ${JSON.stringify(item)}`);
    item.RateDesc = '';

    return (
      <div>
        <div className="listSLScanRow37" onClick={(e) => this.displayAddItemToOrder(item,rowIdx,false)}>
          <div className="listSLSText">
            <span className="listScanItemName">{item.ItemName}
            </span><br />
            <p className="listScanItemDesc">{item.ItemDescription}</p>
          </div>
          <div className="listSLBuyDiv">
            {item.RateTypeID > 1 ?
              <>
                <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
                <span className="listScanWht">{item.Weight} grams</span>
              </>
              :
              <>
                {item.ItemPrice > 0 ?
                  <>
                    <span>{moneyFormat(item.ItemPrice)}</span> <br style={{ lineHeight: '0px',}} />
                    {item.Quantity > 1 ?
                      <span className="listScanCount" > &nbsp; x {item.Quantity}</span> : null}
                  </> : null}
              </>}
            {item.TotalPrice > 0 ?
              <span className="listScanTotal" >{moneyFormat(item.TotalPrice)} &nbsp;</span> : null}
            <div className="listScanEditDelete">
              <ButtonClear alt="" fill={SessionInfo.activeColor} id="DeleteG" title={`Delete ${item.ItemName}`} className="listScanBtn2" onClick={(e) => this.removeSLQuickItem(e,item)} />
            </div>
          </div>
        </div>
      </div>
    );
  }
  SLQuickItemsFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listSLFooter'>
        <div style={{ left: '20px' }}>
          {/*<span> &nbsp; &nbsp; &nbsp;Receipts Total: &nbsp;</span>*/}
          {/*<span style={{ fontWeight: 'bold' }}>{moneyFormat(this.state.TotalReceiptsPrice)}</span>*/}
          <br />
        </div>
      </ListViewFooter>
    );
  }
  //-------------------------------------------------------------------------------------------------------
  //------------------------- Render ------------------------------------------------------------------
  render() {
    if (!SessionInfo.session || SessionInfo.session === '')
      return (<Navigate to='/' />);
    return (
      <div id="ScannerPage" className="pageMain">
        <div id="hdr" className="headerScanner" onClick={(e) => this.closePopups(0)}>
          <div className="headerTop">
            <div className="headerLeft">
              <div onClick={this.gotoLanding}>&nbsp; {this.backPrompt}</div>
            </div>
            <div className="headerScanCenter"> {/* onClick={(e) => this.closePopups(6)}>*/}
              <div className="headerCenterR3">
                <List alt="" stroke={SessionInfo.ECV.BrandColor} id="ListBtn" title={`View Lists`} className="functionImageL" onClick={(e) => this.openLists()} /> :
              </div>
              <div className="headerCenterR2">
                <ShoppingCart stroke={SessionInfo.ECV.BrandColor} count={this.state.NetItemCount} />
              </div>
              <div className="headerCenterMenu">
                {SessionInfo.loggedOn === true && SessionInfo.accountLogon == true ?
                  <MenuBar alt="" fill={SessionInfo.ECV.BrandColor} id="MenuBtn" title={`View Menu`} className="functionImageL" onClick={(e) => this.openMenu(e)} ref={this.menuAnchor} /> :
                  <span className="signin" onClick={(e) => this.signIn()}>Sign In</span>}
              </div>
              {SessionInfo.AppCfg.HasDelivery === true ?
                <div className="headerOrderTopRightTop">
                  <div className="orderDiv">
                    <Button id="orderTypeButton" onClick={this.orderTypeClick} >Order Type</Button>
                  </div>
                  <div className="orderTypeDiv">
                    <span className='landingHeadText' >{this.state.currentOrderTypeName}</span>
                  </div>
                </div> :
                <>
                  {this.state.SeatCount <= 1 && SessionInfo.AC.HasGuest === true ?
                    <div>
                      <span className='landingHeadTextReg'>&nbsp; &nbsp; &nbsp; Guest:</span>
                      <span className='landingHeadText' >&nbsp;{SessionInfo.logonName}</span>
                    </div> : null}
                </>}
            </div>

            {/*<div className="headerOrderTopCenter">
              <span className='landingHeadText' style={{color:'black'}}>{this.state.StoreName}</span>
            </div>*/}
          </div>

          <div className="headerMiddle" ref={(div) => { this.shoppingListsAnchor = div; }}>
            <div className="headerSpecial">
            </div>
            <div className="headerStoreInfo">
              {this.state.showStoreInfo ?
                <div className="headerLocation">
                  <div className="landingTextXXXL" >{SessionInfo.SLV.Description}
                    {SessionInfo.debug ?
                      <span className='landingHeadTextSmall'>&nbsp;&nbsp;{SessionInfo.appVersion}-{SessionInfo.Platform}</span> : null}</div>
                  <div className="landingTextXXL" >&nbsp; {this.state.HoursForToday}</div>
                </div> : null}
            </div>
            <div className="headerMessage">
              {this.state.showNotify ?
                <>
                  <div dangerouslySetInnerHTML={{ __html: this.state.notifyMessage }} onClick={(e) => { this.acknowledgeMessage(); }} />
                  {SessionInfo.acknowledge ?
                    <div className="bottomButton">
                      <Button icon="tell-a-friend" className="mediumButton" onClick={this.acknowledgeMessage}>Acknowledge</Button>
                    </div> : null}
                </> : null}
            </div>
          </div>

          <div className="headerBottom">
            <div className="headerOrderBotSearch">
              <div id="headerSearch">
                <div id="searchBtnDiv">
                  <Tooltip position="top" anchorElement="pointer">
                    <ButtonSearch alt="" fill={SessionInfo.searchColor} title={`Search Menu`} className="functionImage" onClick={this.searchButton} />
                  </Tooltip>
                </div>
                <div id="searchBoxDiv">
                  <FloatingLabel label='Search Items' style={{ width: '300',color: 'darkblue' }} editorId={'search-id'} editorValue={this.state.searchValue}>
                    <Input value={this.state.searchValue} autoComplete="off" onChange={evt => this.updateSearchValue(evt)} className='searchInput' />
                  </FloatingLabel>
                </div>
                {this.state.searchValue.length > 0 ?
                  <div id="clearSearchBtnDiv">
                    <Tooltip position="top" anchorElement="pointer">
                      <ButtonClear alt="" fill={SessionInfo.searchColor} title={`Clear Search Box`} className="functionImage" onClick={this.clearSearch} />
                    </Tooltip>
                  </div> : null}
              </div>
            </div>

            <div id="div3" className="headerSCNLeftScan">
              {this.state.imgVideoVisible === true ?
                <div className="barcodeScannerBox">
                  <video id="scannerVideo" width={scanWD + "px"} height={scanHT + "px"} margin='1' padding='1' style={{ border: '1px solid gray',}} />
                  <div className="barcodeMessage">{this.state.barcodeMessage}</div>
                </div> : null}
              <div className="headerSCNButton">
                {this.state.showScan === true ?
                  <>
                    {hideScannerAfterScan === true ?
                      <Button className="scanButton" icon="restore" onClick={this.startScan} >&nbsp;&nbsp; Scan Item &nbsp;&nbsp;</Button>
                      :
                      <Button className="scanButton" icon="restore" onClick={this.startScan} >&nbsp;&nbsp; Scan Items &nbsp;&nbsp;</Button>}
                  </>
                  :
                  <Button className="scanButton" icon="refresh" onClick={this.onCancelScan}>&nbsp;&nbsp; Hide Scanner &nbsp;&nbsp;</Button>
                }
              </div>
            </div>
            {/* Menu Popup */}
            <Popup anchor={this.menuAnchor.current} show={this.state.showMenu} popupClass={'popupMenuO'} >
              <div className="mainMenu">
                <a id="headerLogo" style={{ backgroundImage: `url(${SessionInfo.LogoImageURL})`,backgroundPosition: 'left top',backgroundRepeat: 'no-repeat',backgroundSize: '100px 60px' }} href="http://www.omnovos.com" target="_blank" rel="noopener noreferrer" />
                <div className="menuTree">
                  {SessionInfo.AppCfg.ScanAndPay === false ?
                    <br /> : null}
                  {/*{SessionInfo.defaultLogon === true ?*/}
                  {/*  <br /> : null}*/}
                  <TreeView
                    data={SessionInfo.MenuControlO}
                    size='large' draggable='false' selection='single'
                    onItemClick={this.onMenuItemClick}
                    className='menuTreeSub'
                    item={props => [<span key={props.item.key} className={props.item.className}>{props.item.icon}{props.item.space}{props.item.text}</span>]}
                  />
                </div>
              </div>
            </Popup>
          </div>
        </div>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        {/* This is the SCANNER Item Detail Popup */}
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup anchor={this.shoppingListsAnchor} show={this.state.displayItemDetail} popupClass={'popupItemDetail'} >
          <div className="itemSelection" onScroll={evt => this.scrollOptions(evt)}>   {/* Scrolling Div */}
            <div className="itemDetailHeader">
              <div className="optionTopInfo">  {/* Back and Image */}
                <div className="optionTop">
                  <div className="optionLeft">
                    <div onClick={this.cancelDetailAdd}>&nbsp; {this.backAddItem}</div> 
                  </div>
                  <div className="optionOrderRight">
                    <div className="optionCenterR2">
                      <ShoppingCart stroke={SessionInfo.ECV.BrandColor} count={this.state.NetItemCount} />
                    </div>
                  </div>
                </div>
                {/*-------- Image -----------------------------------------*/}
                <div className="optionTopImage">
                  {/*<Slide direction="vertical">*/}
                  {this.state.hideOptionImage == false ?
                    <div className="optionFlexPic">
                      <Avatar rounded='large' size='large' type='image' className='optionFramePic'>
                        <img src={this.state.ProductItemPhotoURL} style={{ objectFit: 'fill',}} />
                      </Avatar>
                    </div> : null}
                  {/*</Slide>*/}
                </div>
                {/*----- Header Item Description, Price, Quantity and Instructions */}
                <div className="optionHeaderDesc">
                  <div className="infoDescName" >{this.state.ItemName}</div>
                  <div className="infoDescription" style={{ height: this.state.DescHeight }}>
                    <span >{this.state.ItemDescription}</span> <br />
                  </div>
                  <div style={{ height: 39,width: '100%',marginTop: 3 }}>
                    <span style={{ fontSize: 18,color: "black",marginLeft: 7,}} > &nbsp; &nbsp; Price: </span>
                    <span style={{ fontSize: 20,color: "black",fontWeight: "bold",}} > &nbsp; {moneyFormat(this.state.Price)}</span>
                    <span style={{ fontSize: 16,color: "black",fontWeight: "bold",}} >&nbsp;&nbsp;</span>
                    {this.state.RateTypeID <= 1 ?
                      <NumericTextBox name="Quantity" className="NumQuantity" value={this.state.Quantity} spinners={true} step={1} title="Qty" min={0} max={20} onChange={this.changeQuantity} width="75px" /> :
                      <NumericTextBox name="Weight" className="NumQuantity" value={this.state.Weight} spinners={true} step={50} title="Qty" min={0} max={2000} onChange={this.changeWeight} width="100px" />}
                    <span style={{ fontSize: 16,color: "black",}} >&nbsp;</span>
                    {/*<CartAdd alt="" stroke={SessionInfo.addColor} id="AddItemBtn" title={`Add New Item to the Order`} className="listCartAdd" onClick={(e) => this.addDetailItemToOrder()} />*/}
                    {this.state.itemChanged === true ?
                      <Button className="smallButton" icon="edit" onClick={this.changeItemOnOrder}>Save</Button> : null}
                  </div>
                  <div className='optionTotalPrice'>
                    <span style={{ fontSize: 18,color: "black" }} >&nbsp;&nbsp; &nbsp; &nbsp;Total: </span>
                    <span style={{ fontSize: 20,color: "black",fontWeight: "bold" }} >&nbsp; {moneyFormat(this.state.TotalPrice)}</span>
                    {this.state.PromotionPrice > 0 && this.state.PromotionPrice < this.state.ItemPrice ?
                      <span style={{ fontSize: 16,color: "blue",fontWeight: "bold" }} >&nbsp; &nbsp; &nbsp; &nbsp; Promo Price:&nbsp;{moneyFormat(this.state.PromotionPrice)}</span> : null} {/* &nbsp;&nbsp;&nbsp;({this.state.PromotionType}) */}
                  </div>
                  {this.state.showInfo === true ?
                    <div className="optionInst">
                      <FloatingLabel label="Special Instructions" style={{ width: '300',color: 'darkblue' }} editorId={"SpecInstruction"} editorValue={this.state.SpecialInstruction} >
                        <TextArea id={"SpecInstruction"} name={"SpecialInstruction"} value={this.state.SpecialInstruction} ariaLabelledBy={"labelID"} autoComplete="off" style={{ width: '340px',resize: 'none' }} maxLength={140} onChange={evt => this.chgTAInfoFldVal(evt)} autoSize={true} rows={2} ariaDescribedBy={"hintID"} />
                        {/*  <Hint id={"hintID"} style={{ width: '250px' }} direction={"end"}>Special Instructions &nbsp;&nbsp;&nbsp;&nbsp;{this.state.SpecialInstruction === undefined ? -1 : this.state.SpecialInstruction.length} / 140 </Hint>*/}
                      </FloatingLabel>
                    </div> : <br />}
                </div>
              </div>
            </div>
            {/*----- List Section - List of OrderItems or List of Options & Related - Deleted - Copy from OrderPage */}
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        {/* Shopping List Full Item Entry  */}
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup anchor={this.shoppingListsAnchor} show={this.state.displaySLItem} popupClass={'popupSLItem'} >
          <div className="itemSelection" onScroll={evt => this.scrollOptions(evt)}>   {/* Scrolling Div */}
            <div className="headerSL">
              <div className="headerSLItem">
                {/*<div className="shoppingListTopInfo">*/}
                <div className="shoppingListTop">
                  <div className="shoppingListLeft">
                    <div onClick={this.cancelSLItem}>&nbsp; {this.backSLItemPrompt}</div>
                  </div>
                  <div className="shoppingListRight2">
                    <div onClick={this.useSLQuick}>{this.useSLQuickPrompt}</div>
                  </div>
                </div>

                <div className="headerSLCenterTop">
                  <span className='landingHeadTextLarge' >Item: {this.state.ItemName}</span>
                </div>
                <div className="headerRecCenterMid">
                  {this.state.itemChanged === true ?
                    <Button className="SLButton" icon="star-outline" onClick={this.saveSLItem} >Save Item</Button> :
                    <>
                      {this.state.itemSaved === true && this.editSLItem === false ?
                        <Button className="SLButton" icon="star-outline" onClick={this.addNewSLItem} >Add New Item</Button> : null}
                    </>}
                </div>
                {this.state.StoreItemID === 0 ?
                  <div className="headerScanSearchItem">
                    <div id="headerSearchSLwide">
                      <div id="searchBtnDivSL">
                        <Tooltip position="top" anchorElement="pointer">
                          <ButtonSearch alt="" fill={SessionInfo.searchColor} title={`Search Menu`} className="functionImage" onClick={this.searchButtonOM} />
                        </Tooltip>
                      </div>
                      <div id="searchBoxDivSLwide">
                        <FloatingLabel label='Search Items' style={{ width: '300',color: 'darkblue' }} editorId={'search-id'} editorValue={this.state.searchValue}>
                          <Input value={this.state.searchValue} autoComplete="off" onChange={evt => this.updateOMSearchValue(evt)} className='searchInputSL' />
                        </FloatingLabel>
                      </div>
                      {this.state.searchValue.length > 0 ?
                        <div id="clearSearchBtnDivSL">
                          <Tooltip position="top" anchorElement="pointer">
                            <ButtonClear alt="" fill={SessionInfo.searchColor} title={`Clear Search Box`} className="functionImage" onClick={this.clearSearch} />
                          </Tooltip>
                        </div> : null}
                    </div>
                  </div> : null}
              </div>
              <div className="editSLItemInfo">
                <div className='editSLItemField'>
                  <span className='editSLItemLabel'>Item Name</span>
                  <input value={this.state.ItemName} name='ItemName' onChange={evt => this.chgItemNameVal(evt)} className='editSLItemInput' />
                </div>
                <div className='editSLTAField'>
                  <span className='editSLItemLabel'>Item Description</span>
                  <textarea value={this.state.ItemDescription} name='ItemDescription' onChange={evt => this.chgItemDescVal(evt)} className='editSLTAInput' />
                </div>
                {this.state.StoreItemID > 0 ?
                  <>
                    <div className='editSLSpecField'>
                      <span style={{ position: 'absolute',fontSize: 18,color: "black",left: '1px',}} >Price: </span>
                      <span style={{ position: 'absolute',fontSize: 20,color: "black",fontWeight: "bold",left: '65px',}} > &nbsp; {moneyFormat(this.state.ItemPrice)}</span>
                      {this.state.RateTypeID == 1 ?
                        <>
                          <span style={{ position: 'absolute',fontSize: 18,color: "black",left: '160px',}} >Quantity: </span>
                          <NumericTextBox name="Quantity" className="NumSLQuantity" value={this.state.Quantity} spinners={true} step={1} title="Qty" min={0} max={20} onChange={this.changeQuantity} width="75px" />
                        </> :
                        <>
                          <span style={{ position: 'absolute',fontSize: 18,color: "black",left: '155px',}} >Weight: &nbsp;</span>
                          <NumericTextBox name="Weight" className="NumSLQuantity" style={{ left: '225px',}} value={this.state.Weight} spinners={true} step={50} title="Qty" min={0} max={2000} onChange={this.changeWeight} width="100px" />
                        </>}
                      <span style={{ position: 'absolute',fontSize: 18,color: "black",left: '1px',top: '30px' }} >Total: </span>
                      <span style={{ position: 'absolute',fontSize: 20,color: "black",fontWeight: "bold",left: '65px',top: '30px',}} >{moneyFormat(this.state.TotalPrice)}</span>
                    </div>
                  </> : null}
              </div>

            </div>
            {this.state.searchForItems ?
              <div className="SLItemSearch">
                <ListView data={this.state.SearchItems} item={this.ShoppingListItemsFormat} header={this.OrderItemHeader} footer={this.OrderItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
              </div>
              : null}
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        {/* Shopping List Quick Item Entry                      */}
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup anchor={this.shoppingListsAnchor} show={this.state.displaySLQuick} popupClass={'popupSLItem'} >
          <div className="itemSelection" onScroll={evt => this.scrollOptions(evt)}>   {/* Scrolling Div */}
            <div className="headerSL">
              <div className="headerSLItem">
                {/*<div className="shoppingListTopInfo">*/}
                <div className="shoppingListTop">
                  <div className="shoppingListLeft">
                    <div onClick={this.finshSLQuickItem}>&nbsp; {this.backSLItemPrompt}</div>
                  </div>
                  <div className="shoppingListRight2">
                    <div onClick={this.addNewSLItem}>{this.useSLDetailPrompt}</div>
                  </div>
                </div>

                <div className="headerSLQCenterTop">
                  <span className='editSLItemLabel'>Item Name</span>
                  <input value={this.state.ItemName} name='ItemName' onChange={evt => this.chgFldVal(evt)} className='editSLItemInput' autoComplete='off' ref={this.itemNameAnchor} />
                </div>
                <div className="headerSLQCenterTop2">
                  <span className='editSLItemLabel'>Item Description</span>
                  <textarea value={this.state.ItemDescription} name='ItemDescription' onChange={evt => this.chgFldVal(evt)} className='editSLQTAInput' autoComplete='off' />
                </div>
                <div className="headerRecFarRight">
                  <CartAdd alt="" stroke={SessionInfo.ECV.PurchasedColor} id="ChooseItemBtn" title={`Add Current Item ${this.state.ItemName}`} className="listScanBtn0" onClick={(e) => this.addSLQuickItem(e)} />
                </div>
              </div>

            </div>
            <div className="SLQuickItems">
              <ListView data={this.state.SLQuickItems} item={this.SLQuickItemsFormat} header={this.SLQuickItemHeader} footer={this.SLQuickItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
            </div>
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        {/* Shopping List */}
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup anchor={this.shoppingListsAnchor} show={this.state.displayShoppingList} popupClass={'popupShoppingList'} >
          <div className="shoppingList" onScroll={evt => this.scrollSList(evt)}>   {/* Scrolling Div */}
            <div className="headerSL">
              {/*<div className="shoppingListTopInfo">*/}
              <div className="shoppingListTop">
                <div className="shoppingListLeft">
                  <div onClick={this.cancelShoppingList}>&nbsp; {this.backSListPrompt}</div>
                </div>
                <div className="shoppingListRight">
                  <div onClick={this.useShoppingList}>{this.useSListPrompt}</div>
                </div>
              </div>
              {this.state.inAddSLList || this.state.inEditSLList ?
                <>
                  <div className="headerSLCenterTop">{this.state.ShoppingListName}</div>
                  <div className="headerSLCenterTop2">{this.state.SLDescription}</div>
                  <div className="headerRecBottomRight">
                    {this.state.inAddSLList ?
                      <Button className="SLButton" icon="star-outline" onClick={this.addNewSList} >Save New List</Button> :
                      <Button className="SLButton" icon="star-outline" onClick={this.saveSList} >Save Changes</Button>}
                  </div>
                </> :
                <>
                  <div className="headerSLCenterTop">{this.state.ShoppingListName}</div>
                  <div className="headerSLCenterTop2">{this.state.SLDescription}</div>
                  <div className="headerScanSearch">
                    <div id="headerSearchSL">
                      <div id="searchBtnDivSL">
                        <Tooltip position="top" anchorElement="pointer">
                          <ButtonSearch alt="" fill={SessionInfo.searchColor} title={`Search Menu`} className="functionImage" onClick={this.searchButtonSLItem} />
                        </Tooltip>
                      </div>
                      <div id="searchBoxDivSL">
                        <FloatingLabel label='Search List' style={{ width: '300',color: 'darkblue' }} editorId={'search-id'} editorValue={this.state.searchSLItemValue}>
                          <Input value={this.state.searchSLItemValue} autoComplete="off" onChange={evt => this.updateSearchSLItemValue(evt)} className='searchInputSL' />
                        </FloatingLabel>
                      </div>
                      {this.state.searchSLItemValue.length > 0 ?
                        <div id="clearSearchBtnDivSL">
                          <Tooltip position="top" anchorElement="pointer">
                            <ButtonClear alt="" fill={SessionInfo.searchColor} title={`Clear Search Box`} className="functionImage" onClick={this.clearSearch} />
                          </Tooltip>
                        </div> : null}
                    </div>
                  </div>
                  <div className="headerRecBottomRight">
                    <Button className="SLButton" icon="star-outline" onClick={this.addNewSLItem} >Add New Item</Button>
                  </div>
                </>}
            </div>
            {this.state.inAddSLList || this.state.inEditSLList ?
              <div className="editSLItemInfo">
                <div className='editSLItemField'>
                  <span className='editSLItemLabel'>List Name</span>
                  <input value={this.state.ShoppingListName} name='ShoppingListName' onChange={evt => this.chgFldVal(evt)} className='editSLItemInput' />
                </div>
                <div className='editSLTAField'>
                  <span className='editSLItemLabel'>List Description</span>
                  <textarea value={this.state.SLDescription} name='SLDescription' onChange={evt => this.chgFldVal(evt)} className='editSLTAInput' />
                </div>
              </div>
              :
              <div className="editSLItemInfo">
                <ListView data={this.state.ShoppingListItems} item={this.ShoppingListItemsFormat} style={{ width: "99%",backgroundColor: 'rgba(240, 240, 240, 0.75)',left: '2px' }} header={this.ShoppingListItemsHeader} footer={this.ShoppingListItemsFooter} />
              </div>}
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        {/* List of Shopping Lists */}
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup anchor={this.shoppingListsAnchor} show={this.state.displayShoppingLists} popupClass={'popupShoppingLists'} >
          <div className="shoppingLists" onScroll={evt => this.scrollSList(evt)}>   {/* Scrolling Div */}
            <div className="headerSLs">
              <div className="shoppingListsTop">
                <div className="shoppingListsLeft">
                  <div onClick={this.cancelShoppingLists}>&nbsp; {this.backScannerPrompt}</div>
                </div>
              </div>

              <div className="headerSLsCenterTop">
                <span className='landingHeadTextLarge' >Shopping Lists</span>
              </div>
              <div className="headerRecCenterMid">
                <Button className="SLButton" icon="star-outline" onClick={this.displayNewShoppingList}>Add New List</Button>  {/* onClick={this.displayAShoppingList()} - this executes on page load */}
              </div>
              <div className="headerListsScanSearch">
                <div id="headerSearchSLs">
                  <div id="searchBtnDivSLs">
                    <Tooltip position="top" anchorElement="pointer">
                      <ButtonSearch alt="" fill={SessionInfo.searchColor} title={`Search Menu`} className="functionImage" onClick={this.searchButtonSL} />
                    </Tooltip>
                  </div>
                  <div id="searchBoxDivSLs">
                    <FloatingLabel label='Search Lists' style={{ width: '300',color: 'darkblue' }} editorId={'search-id'} editorValue={this.state.searchSLValue}>
                      <Input value={this.state.searchSLValue} autoComplete="off" onChange={evt => this.updateSearchSLValue(evt)} className='searchInputSL' />
                    </FloatingLabel>
                  </div>
                  {this.state.searchSLValue.length > 0 ?
                    <div id="clearSearchBtnDivSLs">
                      <Tooltip position="top" anchorElement="pointer">
                        <ButtonClear alt="" fill={SessionInfo.searchColor} title={`Clear Search Box`} className="functionImage" onClick={this.clearSearch} />
                      </Tooltip>
                    </div> : null}
                </div>
              </div>
            </div>
            {/*----- List Section - List of Available Shopping Lists */}
            <div className="shoppingListsView">
              <ListView data={this.state.ShoppingLists} item={this.ShoppingListsFormat} style={{ width: "99%",backgroundColor: 'rgba(240, 240, 240, 0.75)',left: '2px' }} header={this.ShoppingListsHeader} footer={this.ShoppingListsFooter} />
            </div>
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup offset={this.addPopupOffset} show={this.state.showVerifyRemoveItem} popupClass={'popupStandard'} >
          <div id="seatBox">
            <br />
            <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp; Remove:&nbsp;</span><span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >{this.deleteItem.ItemName}</span>
            <br />
            <br />
            <br />
            <Button id="verifyButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={(e) => this.verifiedRemoveItem(e)} >&nbsp;Yes - Remove</Button>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Button id="cancelButton" icon="cancel" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={(e) => this.cancelRemoveItem(e)} >&nbsp;No - Keep&nbsp;</Button>
            <br />
            <br />
            <br />
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup offset={this.addPopupOffset} show={this.state.showVerifyRemoveSLItem} popupClass={'popupStandard'} >
          <div id="seatBox">
            <br />
            <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp; Remove Shopping List Item:</span><br />
            <span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >&nbsp; &nbsp; {this.deleteItem.ItemName}</span>
            <br />
            <br />
            <br />
            <Button id="verifyButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={(e) => this.verifiedRemoveSLItem(e)} >&nbsp;Yes - Remove</Button>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Button id="cancelButton" icon="cancel" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={(e) => this.cancelRemoveSLItem(e)} >&nbsp;No - Keep&nbsp;</Button>
            <br />
            <br />
            <br />
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        <Popup offset={this.addPopupOffset} show={this.state.showVerifyRemoveSL} popupClass={'popupStandard'} >
          <div id="seatBox">
            <br />
            <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp; Remove Shopping List:</span><br /><span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >&nbsp; &nbsp; {this.deleteItem.ShoppingListName}</span>
            <br />
            <br />
            <br />
            <Button id="verifyButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={(e) => this.verifiedRemoveSL(e)} >&nbsp;Yes - Remove</Button>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Button id="cancelButton" icon="cancel" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '20px' }} onClick={(e) => this.cancelRemoveSL(e)} >&nbsp;No - Keep&nbsp;</Button>
            <br />
            <br />
            <br />
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        {/* Bill Review and Rating Popup */}
        <Popup offset={this.billPopupOffset} show={this.state.showBillSummary} popupClass={'popupStandard'} >  {/**/}
          <div id="seatBox">
            <br />
            <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }} >&nbsp;Shopping for :&nbsp;</span><span style={{ fontSize: 15,color: "black",fontWeight: "bold" }} >{SessionInfo.PersonInfo.FirstName} {SessionInfo.PersonInfo.LastName}</span>
            <br />
            <br />
            <br />
            {this.state.TotalBill > 0 ?
              <div id="div2" className="editField">
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>Total Bill: &nbsp;&nbsp;&nbsp;</span>
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{moneyFormat(this.state.TotalBill)}</span>
              </div> :
              <div id="div2" className="editField">
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>Your Bill Has Been Paid</span>
              </div>}
            {this.state.TotalTip > 0 ?
              <div id="div2" className="editField">
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>Total Tip: &nbsp;&nbsp;&nbsp;</span>
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}>{moneyFormat(this.state.TotalTip)}</span>
              </div> : null}
            {this.state.BillCount > 1 ?
              <div id="div2" className="editField">
                <span style={{ fontSize: 16,color: "black",fontWeight: "bold" }}># of Bills Paid: {this.state.PaidBills}&nbsp;of&nbsp;{this.state.BillCount}&nbsp;</span>
              </div> : null}
            <div style={{ height: "50px",paddingLeft: '6px' }}>
              <span className="editFieldLabel" style={{ fontSize: '16px' }}>Rate your experience</span>
              <br />
              <Rating value={this.state.RatingValue} name="RatingValue" selection={"continues"} className='ratingStars' defaultValue={0} max={5} onChange={evt => this.chgRateVal(evt)} />
            </div>
            <div className="editTAField">
              {/*  <FloatingLabel label="Comment on your Rating" style={{ width: '300',color: 'darkblue' }} editorId={"ServiceDescription"} editorValue={this.state.ServiceDescription} >*/}
              {/*    <TextArea id={"ServiceDescription"} name={"ServiceDescription"} value={this.state.SpecialInstruction} ariaLabelledBy={"labelID"} autoComplete="off" style={{ marginLeft: '5px', width: '95%',marginTop: '3px',resize: 'none' }} maxLength={140} onChange={evt => this.chgFldVal(evt)} className="editTAInputFull" />*/}
              {/*  </FloatingLabel>*/}
              <span className="editFieldLabel">Comment on your Rating</span>
              <br />
              <textarea value={this.state.ServiceDescription} name="ServiceDescription" autoComplete="off" style={{ marginLeft: '5px',marginTop: '3px',resize: 'none' }} onChange={evt => this.chgFldVal(evt)} className="editTAInputFull" />
            </div>
            <br />
            <br />
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Button id="doneButton" icon="checkbox-checked" style={{ cursor: 'pointer',fontSize: '12',color: 'black',fontWeight: 'bold',borderRadius: '5px',left: '20px',height: '25px' }} onClick={this.doneComment} >&nbsp;OK&nbsp;</Button>
            <br />
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </div>
        </Popup>
        {/*--------------------------------------------------------------------------------------------------------------------------------------------------------*/}
        {SessionInfo.AC.ScanItemImages ?
          <>
            {SessionInfo.HasMenuImage ?
              <div className="scanList" style={{ backgroundImage: `url(${SessionInfo.BackgroundImageURL})` }} >
                {useAlt === false ?
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormat} header={this.OrderItemHeader} footer={this.OrderItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                  :
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormatAlt} header={this.OrderItemHeader} footer={this.OrderItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />}
              </div>
              :
              <div className="scanList">
                {useAlt === false ?
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormat} header={this.OrderItemHeader} footer={this.OrderItemFooter} />
                  :
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormatAlt} header={this.OrderItemHeader} footer={this.OrderItemFooter} />}
              </div>}
          </> : <>
            {SessionInfo.HasMenuImage ?
              <div className="scanList" style={{ backgroundImage: `url(${SessionInfo.BackgroundImageURL})` }} >
                {useAlt === false ?
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormatNP} header={this.OrderItemHeader} footer={this.OrderItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />
                  :
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormatAlt} header={this.OrderItemHeader} footer={this.OrderItemFooter} style={{ backgroundColor: SessionInfo.orderBGColor,backgroundRepeat: 'repeat-y',overflow: 'hidden' }} />}
              </div>
              :
              <div className="scanList">
                {useAlt === false ?
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormatNP} header={this.OrderItemHeader} footer={this.OrderItemFooter} />
                  :
                  <ListView data={this.state.OrderItems} item={this.OrderItemFormatAlt} header={this.OrderItemHeader} footer={this.OrderItemFooter} />}
              </div>}
          </>}
        <div id="hdr" className="footerOrder" >
          <div className='orderFooterLeftTop'>
            {/*<div className="orderMsg">{this.state.orderMessage}</div>*/}
            {SessionInfo.AC.HasTotals === true ?
              <>
                <span className='listName'>Cart Subtotal </span>
                <span className='listMoneyTot'>{moneyFormat(this.state.SubTotalPrice)}</span>
                {/*<br />
                <span className='listName'>Tax </span>
                <span className='listMoneyTot'>{moneyFormat(this.state.TotalTaxAmount)}</span>
                <br />
                <span className='listName'>TOTAL </span>
                <span className='listMoneyTot'>{moneyFormat(this.state.TotalPrice)}</span>*/}
              </> : null}
            <div className='scanFooterRight'>
              {SessionInfo.AC.HasShoppingCart === true && (this.state.ItemCount > 0 || this.state.SeatCount > 1) ?
                <ShoppingCart stroke={SessionInfo.headingTextColor} count={this.state.NetItemCount} /> : null}
            </div>
          </div>
          <div className='scanFooterLeftBot'>
            {this.state.showScan === true ?
              <>
                {hideScannerAfterScan === true ?
                  <Button className="scanButton" icon="restore" onClick={this.startScan} >&nbsp;&nbsp; Scan Item &nbsp;&nbsp;</Button>
                  :
                  <Button className="scanButton" icon="restore" onClick={this.startScan} >&nbsp;&nbsp; Scan Items &nbsp;&nbsp;</Button>}
              </>
              :
              <Button className="scanButton" icon="refresh" onClick={this.onCancelScan}>&nbsp;&nbsp; Hide Scanner &nbsp;&nbsp;</Button>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ScannerPage);